(function() {
  'use strict';

  /* ═══════════════════════════════════════════════════════════════
     NEW FOOTWEAR PRODUCT — Variant-Based Image Filtering (Filename Match)
     ═══════════════════════════════════════════════════════════════
     HOW IT WORKS:
     - Each image has data-image-filename (e.g. "black2.jpg", "red1.png")
     - When a color variant is selected (e.g. "Red"), we normalize it
       to "red" and check if each filename STARTS WITH that color.
     - "black2.jpg" starts with "black" → belongs to Black
     - "reddress.png" starts with "red" → belongs to Red
     - "grey1.jpg" starts with "grey" → belongs to Grey
     - "lightgrey3.jpg" starts with "lightgrey" → belongs to Light Grey

     NAMING RULE:
     Just name your images starting with the color name:
       Red 1.jpg, Red 2.jpg, Black 1.jpg, Grey Dress.jpg
     Shopify converts spaces/special chars, so "Red 1.jpg" → "red_1.jpg"
     The code handles all these normalizations automatically.
     ═══════════════════════════════════════════════════════════════ */

  /* XHR-based cart add — bypasses Dawn's fetch() interceptor that causes duplicates */
  function cozyRenderSavings(cart) {
    var totalRow = document.querySelector('.new-footwear-cart-drawer__total');
    if (!totalRow) return;
    var el = document.getElementById('cozy-cart-savings');
    if (!cart || !cart.total_discount) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('div');
      el.id = 'cozy-cart-savings';
      el.style.cssText = 'display:flex;justify-content:space-between;align-items:center;font-size:13px;font-weight:700;color:#2E7D4F;margin:0 0 6px;';
      totalRow.parentNode.insertBefore(el, totalRow);
    }
    el.innerHTML = '<span>You\'re saving</span><span>' + formatMoney(cart.total_discount) + '</span>';
  }

  /* Necklace drawer only (gated on the .fn-incl block existing in the drawer):
     compare-at strikethroughs on line items + crossed-out compare total + save line.
     Other pages' drawers are untouched — the gate element only renders on family-necklace. */
  function cozyEnhanceComparePrices(cart) {
    if (!document.querySelector('.fn-incl') && !document.getElementById('cozy-cmp-on')) return; /* pages opt in with #cozy-cmp-on (backpack 2026-09-04) */
    if (!cart || !cart.items || !cart.items.length) {
      var e0 = document.getElementById('cozy-total-cmp'); if (e0) e0.remove();
      var s0 = document.getElementById('cozy-cmp-saveline'); if (s0) s0.remove();
      return;
    }
    Promise.all(cart.items.map(function(it) { return fetchProductData(it.handle).catch(function() { return null; }); })).then(function(products) {
      var cmpTotal = 0, anyCmp = false;
      cart.items.forEach(function(item, i) {
        var p = products[i], cmpCents = 0;
        if (p && p.variants) {
          for (var v = 0; v < p.variants.length; v++) {
            if (String(p.variants[v].id) === String(item.variant_id)) {
              var c = Math.round(parseFloat(p.variants[v].compare_at_price || 0) * 100);
              var pr = Math.round(parseFloat(p.variants[v].price || 0) * 100);
              if (c > pr) cmpCents = c;
              break;
            }
          }
        }
        var lineCmp = cmpCents > 0 ? cmpCents * item.quantity : item.final_line_price;
        cmpTotal += lineCmp;
        if (cmpCents > 0) anyCmp = true;
        var row = cartLineItems.querySelector('.new-footwear-cart-item[data-key="' + item.key + '"]');
        if (!row) return;
        var priceEl = row.querySelector('.new-footwear-cart-item__price');
        if (!priceEl || priceEl.classList.contains('new-footwear-cart-item__price--free')) return;
        if (cmpCents > 0 && cmpCents * item.quantity > item.final_line_price) {
          /* 🔒 2026-09-06 (TA): the % badge is pinned to the REGULAR price, so a line carrying the Buy 1 Get 1 discount
             still reads "50% OFF" like its sibling; the green 🎁 line under the price carries the extra 25%. */
          var cozyHasLineDisc = !!(item.line_level_discount_allocations && item.line_level_discount_allocations.some(function(d){ return d.amount > 0; }));
          var cozyPctBase = cozyHasLineDisc ? item.original_line_price : item.final_line_price;
          var pct = Math.round(100 - (cozyPctBase / (cmpCents * item.quantity)) * 100);
          priceEl.innerHTML = '<s class="cozy-cmp-strike">' + formatMoney(cmpCents * item.quantity) + '</s>' +
            '<span class="cozy-price-now">' + formatMoney(item.final_line_price) + '</span>' +
            '<span class="cozy-pct-chip">' + (String(item.product_id) === '8106421256282' ? 'Save ' + formatMoney(cmpCents * item.quantity - item.final_line_price) + ' &#127881;' : pct + '% OFF') + '</span>';
        }
      });
      var totalStrong = document.getElementById('new-footwear-cart-total');
      var cmpEl = document.getElementById('cozy-total-cmp');
      if (anyCmp && cmpTotal > cart.total_price) {
        if (!cmpEl && totalStrong) {
          cmpEl = document.createElement('s');
          cmpEl.id = 'cozy-total-cmp';
          totalStrong.parentNode.insertBefore(cmpEl, totalStrong);
        }
        if (cmpEl) cmpEl.textContent = formatMoney(cmpTotal);
        var save = document.getElementById('cozy-cmp-saveline');
        var totalRow = document.querySelector('.new-footwear-cart-drawer__total');
        if (!save && totalRow) {
          save = document.createElement('div');
          save.id = 'cozy-cmp-saveline';
          totalRow.parentNode.insertBefore(save, totalRow.nextSibling);
        }
        if (save) save.innerHTML = 'You\'re saving <strong>' + formatMoney(cmpTotal - cart.total_price) + '</strong> on this order';
        var dup = document.getElementById('cozy-cart-savings'); if (dup) dup.remove();
      } else {
        if (cmpEl) cmpEl.remove();
        var s2 = document.getElementById('cozy-cmp-saveline'); if (s2) s2.remove();
      }
    });
  }

  function xhrCartAdd(variantId, qty, props) {
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(JSON.parse(xhr.responseText));
        } else {
          reject(new Error('Cart add failed: ' + xhr.status));
        }
      };
      xhr.onerror = function() { reject(new Error('Cart add network error')); };
      var cozyItem = { id: variantId, quantity: qty };
      if (props && Object.keys(props).length) cozyItem.properties = props;
      xhr.send(JSON.stringify({ items: [cozyItem] }));
    });
  }

  var productJSON = document.getElementById('new-footwear-product-json');
  /* SITE-WIDE: don't bail on non-product pages — the cart drawer code below works without
     a product. Only product-specific features (gallery, variant filter, ATC) will skip. */
  var product = productJSON ? JSON.parse(productJSON.textContent) : null;
  var variants = product ? product.variants : [];

  /* DOM references */
  var form = document.getElementById('new-footwear-product-form');
  var variantSelect = document.getElementById('new-footwear-variant-select');
  var atcBtn = document.getElementById('new-footwear-atc-btn');
  var atcText = document.getElementById('new-footwear-atc-text');
  var priceBlock = document.getElementById('new-footwear-price');
  var stickyBar = document.getElementById('new-footwear-sticky-bar');
  var stickyAtc = document.getElementById('new-footwear-sticky-atc');
  var galleryMain = document.getElementById('new-footwear-gallery-main');
  var thumbnails = document.getElementById('new-footwear-thumbnails');
  var dotsContainer = document.getElementById('new-footwear-gallery-dots');
  var cartDrawer = document.getElementById('new-footwear-cart-drawer');
  var cartOverlay = document.getElementById('new-footwear-cart-overlay');
  var cartClose = document.getElementById('new-footwear-cart-close');
  var cartLineItems = document.getElementById('new-footwear-cart-items');
  var cartEmpty = document.getElementById('new-footwear-cart-empty');
  var cartFooter = document.getElementById('new-footwear-cart-footer');
  var cartTotal = document.getElementById('new-footwear-cart-total');
  var cartUpsells = document.getElementById('new-footwear-cart-upsells');
  var cartUpsellItems = document.getElementById('new-footwear-cart-upsell-items');
  var cartScroll = document.getElementById('new-footwear-cart-scroll');
  var prevArrow = document.getElementById('new-footwear-gallery-prev');
  var nextArrow = document.getElementById('new-footwear-gallery-next');

  /* /cart.js returns the shopper's presentment currency, so the symbol and code must follow it —
     hardcoding '$ ... USD' showed dollars to every non-US market */
  var NF_CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: NF_CURRENCY }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2) + ' USD';
    }
  }

  /* Detect which option index is "Color" */
  var colorOptionIndex = -1;
  if (product && product.options) {
    for (var oi = 0; oi < product.options.length; oi++) {
      var optName = (product.options[oi] || '').toLowerCase().trim();
      if (optName === 'color' || optName === 'colour') { colorOptionIndex = oi; break; }
    }
  }

  /* Collect all color values from variants for smart matching */
  var allColorValues = [];
  if (colorOptionIndex >= 0) {
    var seen = {};
    variants.forEach(function(v) {
      var c = v['option' + (colorOptionIndex + 1)];
      if (c && !seen[c]) { seen[c] = true; allColorValues.push(c); }
    });
  }

  var currentColorFilter = null;
  var currentVisibleImages = [];
  var currentVisibleThumbs = [];
  var currentSlideIndex = 0;

  /* ═══════════════════════════════════════════
     FILENAME-BASED COLOR MATCHING
     ═══════════════════════════════════════════
     Normalize a color name to a clean lowercase
     string with no spaces/hyphens/underscores,
     then check if a filename starts with it.

     "Red" → "red"
     "Light Grey" → "lightgrey"
     "Navy Blue" → "navyblue"

     Filename "black2.jpg" → strip to "black2"
     Does "black2" start with "black"? YES
     ═══════════════════════════════════════════ */
  function normalizeForMatch(str) {
    return (str || '').toLowerCase().replace(/[\s\-_]+/g, '');
  }

  function filenameMatchesColor(filename, colorValue) {
    /* Strip extension from filename */
    var fnameClean = normalizeForMatch(filename.replace(/\.[^.]+$/, ''));
    var colorClean = normalizeForMatch(colorValue);
    if (!fnameClean || !colorClean) return false;
    return fnameClean.indexOf(colorClean) === 0;
  }

  function altMatchesColor(el, colorValue) {
    var alt = (el.getAttribute('data-image-alt') || '').toLowerCase().trim();
    var color = (colorValue || '').toLowerCase().trim();
    if (!alt || !color) return false;
    return alt.indexOf(color) !== -1;
  }

  function imageMatchesColor(el, colorValue) {
    /* Try alt text first (more reliable), fall back to filename */
    if (altMatchesColor(el, colorValue)) return true;
    var fn = el.getAttribute('data-image-filename') || '';
    return filenameMatchesColor(fn, colorValue);
  }

  /* ═══════════════════════════════════════════
     IMAGE FILTERING BY COLOR
     ═══════════════════════════════════════════ */
  function filterGalleryByColor(colorValue) {
    if (!galleryMain || !thumbnails) return;
    if (!colorValue) { showAllImages(); return; }

    /* Skip if the color hasn't changed — prevents gallery reset on size change */
    if (currentColorFilter && currentColorFilter.toLowerCase() === colorValue.toLowerCase()) return;

    currentColorFilter = colorValue;

    /* Reorder DOM: move matching images to the FRONT of the gallery */
    var allImages = Array.from(galleryMain.querySelectorAll('.new-footwear-product__gallery-image'));
    var allThumbs = Array.from(thumbnails.querySelectorAll('.new-footwear-product__thumbnail'));

    /* Separate matching and non-matching images */
    var matchingImages = [];
    var otherImages = [];
    allImages.forEach(function(img) {
      if (imageMatchesColor(img, colorValue)) matchingImages.push(img);
      else otherImages.push(img);
    });

    /* Reorder gallery: matching first, then the rest */
    matchingImages.forEach(function(img) { galleryMain.appendChild(img); });
    otherImages.forEach(function(img) { galleryMain.appendChild(img); });

    /* Do the same for thumbnails */
    var matchingThumbs = [];
    var otherThumbs = [];
    allImages.forEach(function(img, idx) {
      /* Find the thumbnail with same data-index as this image */
      var imgIndex = img.getAttribute('data-index');
      var matchThumb = null;
      for (var t = 0; t < allThumbs.length; t++) {
        if (allThumbs[t].getAttribute('data-index') === imgIndex) {
          matchThumb = allThumbs[t];
          break;
        }
      }
      if (matchThumb) {
        if (imageMatchesColor(img, colorValue)) matchingThumbs.push(matchThumb);
        else otherThumbs.push(matchThumb);
      }
    });
    matchingThumbs.forEach(function(thumb) { thumbnails.appendChild(thumb); });
    otherThumbs.forEach(function(thumb) { thumbnails.appendChild(thumb); });

    /* Hide non-matching images and thumbs; keep only the selected color visible. */
    currentVisibleImages = [];
    matchingImages.forEach(function(img) {
      img.style.display = '';
      img.classList.remove('new-footwear-product__gallery-image--hidden');
      currentVisibleImages.push(img);
    });
    otherImages.forEach(function(img) {
      img.style.display = 'none';
      img.classList.add('new-footwear-product__gallery-image--hidden');
    });

    currentVisibleThumbs = [];
    matchingThumbs.forEach(function(thumb) {
      thumb.style.display = '';
      thumb.classList.remove('new-footwear-product__thumbnail--hidden');
      currentVisibleThumbs.push(thumb);
    });
    otherThumbs.forEach(function(thumb) {
      thumb.style.display = 'none';
      thumb.classList.add('new-footwear-product__thumbnail--hidden');
    });

    /* Safety net: if NO images matched (e.g. alt text missing), show everything
       so the user isn't left with an empty gallery. */
    if (matchingImages.length === 0) {
      showAllImages();
      return;
    }

    /* Scroll to the very first visible (matching-color) image */
    currentSlideIndex = 0;
    /* iOS Safari workaround: scroll-snap can stick on hidden snap targets after display:none changes.
       Temporarily disable scroll-snap, reset scroll, force reflow, then re-enable. */
    if (galleryMain) {
      var originalSnap = galleryMain.style.scrollSnapType;
      galleryMain.style.scrollSnapType = 'none';
      galleryMain.scrollLeft = 0;
      /* Force layout reflow */
      void galleryMain.offsetWidth;
      requestAnimationFrame(function() {
        galleryMain.scrollLeft = 0;
        scrollToVisibleIndex(0, false);
        highlightVisibleThumb(0);
        buildDots();
        updateArrowState();
        /* Re-enable scroll-snap on the next frame */
        requestAnimationFrame(function() {
          galleryMain.style.scrollSnapType = originalSnap || '';
        });
      });
    }
  }

  function showAllImages(allImages, allThumbs) {
    if (!allImages) allImages = galleryMain ? galleryMain.querySelectorAll('.new-footwear-product__gallery-image') : [];
    if (!allThumbs) allThumbs = thumbnails ? thumbnails.querySelectorAll('.new-footwear-product__thumbnail') : [];

    currentVisibleImages = [];
    for (var i = 0; i < allImages.length; i++) {
      allImages[i].style.display = '';
      allImages[i].classList.remove('new-footwear-product__gallery-image--hidden');
      currentVisibleImages.push(allImages[i]);
    }
    currentVisibleThumbs = [];
    for (var j = 0; j < allThumbs.length; j++) {
      allThumbs[j].style.display = '';
      allThumbs[j].classList.remove('new-footwear-product__thumbnail--hidden');
      currentVisibleThumbs.push(allThumbs[j]);
    }

    currentSlideIndex = 0;
    requestAnimationFrame(function() {
      scrollToVisibleIndex(0, false);
      highlightVisibleThumb(0);
      buildDots();
      updateArrowState();
    });
  }

  /* ═══════════════════════════════════════════
     GALLERY NAVIGATION
     ═══════════════════════════════════════════ */

  function scrollToVisibleIndex(visIndex, smooth) {
    var visible = currentVisibleImages.length ? currentVisibleImages : getVisibleImages();
    if (visIndex < 0 || visIndex >= visible.length) return;
    currentSlideIndex = visIndex;
    var target = visible[visIndex];
    var behavior = smooth !== false ? 'smooth' : 'auto';
    /* Use getBoundingClientRect for reliable cross-browser position calc — offsetLeft depends on offsetParent which varies with positioning */
    var galleryRect = galleryMain.getBoundingClientRect();
    var targetRect = target.getBoundingClientRect();
    var leftRel = (targetRect.left - galleryRect.left) + galleryMain.scrollLeft;
    galleryMain.scrollTo({ left: leftRel, behavior: behavior });
  }

  function getVisibleImages() {
    if (!galleryMain) return [];
    return Array.from(galleryMain.querySelectorAll(
      '.new-footwear-product__gallery-image:not(.new-footwear-product__gallery-image--hidden)'
    ));
  }

  function highlightVisibleThumb(visIndex) {
    var allThumbs = thumbnails ? thumbnails.querySelectorAll('.new-footwear-product__thumbnail') : [];
    for (var i = 0; i < allThumbs.length; i++) {
      allThumbs[i].classList.remove('new-footwear-product__thumbnail--active');
    }
    var visibleThumbs = currentVisibleThumbs.length ? currentVisibleThumbs :
      Array.from(allThumbs).filter(function(t) {
        return !t.classList.contains('new-footwear-product__thumbnail--hidden');
      });
    if (visIndex >= 0 && visIndex < visibleThumbs.length) {
      visibleThumbs[visIndex].classList.add('new-footwear-product__thumbnail--active');
      visibleThumbs[visIndex].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
  }

  /* Mobile dot indicators */
  function buildDots() {
    if (!dotsContainer) return;
    var visible = currentVisibleImages.length ? currentVisibleImages : getVisibleImages();
    var isMobile = window.innerWidth < 750;
    if (!isMobile || visible.length <= 1) {
      dotsContainer.innerHTML = '';
      dotsContainer.style.display = 'none';
      return;
    }
    dotsContainer.style.display = 'flex';
    var html = '';
    for (var i = 0; i < visible.length; i++) {
      html += '<span class="new-footwear-product__gallery-dot' +
        (i === currentSlideIndex ? ' new-footwear-product__gallery-dot--active' : '') +
        '" data-dot-index="' + i + '"></span>';
    }
    dotsContainer.innerHTML = html;
  }

  function updateDotActive(visIndex) {
    if (!dotsContainer) return;
    var dots = dotsContainer.querySelectorAll('.new-footwear-product__gallery-dot');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('new-footwear-product__gallery-dot--active', i === visIndex);
    }
  }

  function getSlideStep() {
    if (!galleryMain) return 0;
    var visible = currentVisibleImages.length ? currentVisibleImages : getVisibleImages();
    if (!visible.length) return 0;
    var imageWidth = visible[0].offsetWidth;
    var gap = 8;
    if (window.innerWidth < 750) return imageWidth;
    return (imageWidth + gap) * 2;
  }

  function scrollGalleryBy(delta) {
    if (!galleryMain) return;
    galleryMain.scrollBy({ left: delta, behavior: 'smooth' });
    setTimeout(function() {
      syncScrollToSlideIndex();
      updateArrowState();
    }, 350);
  }

  function updateArrowState() {
    if (!galleryMain || !prevArrow || !nextArrow) return;
    var maxScroll = galleryMain.scrollWidth - galleryMain.clientWidth;
    prevArrow.disabled = galleryMain.scrollLeft <= 2;
    nextArrow.disabled = galleryMain.scrollLeft >= maxScroll - 2;
  }

  function syncScrollToSlideIndex() {
    if (!galleryMain) return;
    var visible = currentVisibleImages.length ? currentVisibleImages : getVisibleImages();
    var scrollLeft = galleryMain.scrollLeft;
    var closestIdx = 0;
    var closestDist = Infinity;
    for (var i = 0; i < visible.length; i++) {
      var dist = Math.abs(visible[i].offsetLeft - scrollLeft);
      if (dist < closestDist) {
        closestDist = dist;
        closestIdx = i;
      }
    }
    currentSlideIndex = closestIdx;
    highlightVisibleThumb(closestIdx);
    updateDotActive(closestIdx);
  }

  function showGalleryImageByGlobalIndex(globalIndex) {
    if (!galleryMain) return;
    var visible = currentVisibleImages.length ? currentVisibleImages : getVisibleImages();
    for (var i = 0; i < visible.length; i++) {
      if (parseInt(visible[i].getAttribute('data-index'), 10) === globalIndex) {
        scrollToVisibleIndex(i, true);
        highlightVisibleThumb(i);
        updateDotActive(i);
        return;
      }
    }
  }

  /* ═══════════════════════════════════════════
     VARIANT UPDATE
     ═══════════════════════════════════════════ */
  function updateVariant() {
    var selectedOptions = [];
    product.options.forEach(function(optName, optIndex) {
      var activeSwatch = document.querySelector(
        '.new-footwear-product__color-swatch--active[data-option-index="' + optIndex + '"]'
      );
      if (activeSwatch) {
        selectedOptions[optIndex] = activeSwatch.getAttribute('data-value');
        return;
      }
      var activeSize = document.querySelector(
        '.new-footwear-product__size-btn--active[data-option-index="' + optIndex + '"]'
      );
      if (activeSize) {
        selectedOptions[optIndex] = activeSize.getAttribute('data-value');
        return;
      }
      var selectOpts = variantSelect ? variantSelect.options : [];
      for (var s = 0; s < selectOpts.length; s++) {
        if (selectOpts[s].selected) {
          selectedOptions[optIndex] = selectOpts[s].getAttribute('data-option' + (optIndex + 1));
          break;
        }
      }
    });

    var matchedVariant = variants.find(function(v) {
      return product.options.every(function(opt, i) {
        return v['option' + (i + 1)] === selectedOptions[i];
      });
    });

    /* mark sold-out sizes for the chosen colour even when no size is picked yet */
    nfMarkSoldOutSizes(selectedOptions);

    if (!matchedVariant) return;

    if (variantSelect) {
      for (var o = 0; o < variantSelect.options.length; o++) {
        variantSelect.options[o].selected = (variantSelect.options[o].value === String(matchedVariant.id));
      }
    }

    var url = new URL(window.location);
    url.searchParams.set('variant', matchedVariant.id);
    window.history.replaceState({}, '', url);

    if (priceBlock) {
      if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
        var discount = Math.round((1 - matchedVariant.price / matchedVariant.compare_at_price) * 100);
        priceBlock.innerHTML =
          '<span class="new-footwear-product__price--sale">' + formatMoney(matchedVariant.price) + '</span> ' +
          '<span class="new-footwear-product__price--compare"><s>' + formatMoney(matchedVariant.compare_at_price) + '</s></span> ' +
          '<span class="new-footwear-product__sale-badge">SALE ' + discount + '% OFF</span>';
      } else {
        priceBlock.innerHTML =
          '<span class="new-footwear-product__price--regular">' + formatMoney(matchedVariant.price) + '</span>';
      }
    }

    selectedOptions.forEach(function(val, idx) {
      var optionName = (product.options[idx] || '').toLowerCase().replace(/\s+/g, '-');
      var valueDisplay = document.getElementById('new-footwear-option-' + optionName);
      if (valueDisplay) valueDisplay.textContent = val;
    });

    if (atcBtn && atcText) {
      if (matchedVariant.available) {
        atcBtn.disabled = false;
        atcText.textContent = 'Add to Cart - ' + formatMoney(matchedVariant.price);
      } else {
        atcBtn.disabled = true;
        atcText.textContent = 'Sold Out';
      }
    }

    if (stickyAtc) {
      if (matchedVariant.available) {
        stickyAtc.disabled = false;
        stickyAtc.textContent = 'Add to Cart - ' + formatMoney(matchedVariant.price);
      } else {
        stickyAtc.disabled = true;
        stickyAtc.textContent = 'Sold Out';
      }
    }

    /* ★ FILTER GALLERY BY COLOR ★ */
    if (colorOptionIndex >= 0 && selectedOptions[colorOptionIndex]) {
      filterGalleryByColor(selectedOptions[colorOptionIndex]);
    }
  }

  /* Flags each size button whose variant (in the selected color) is unavailable.
     Uses the theme's existing --unavailable style (faded + line-through).
     Sizes stay clickable so the shopper still sees the "Sold Out" ATC state.
     Re-runs on every colour change. */
  function nfMarkSoldOutSizes(selectedOptions) {
    if (!product || !variants.length) return;
    var color = (colorOptionIndex >= 0 && selectedOptions) ? selectedOptions[colorOptionIndex] : null;

    document.querySelectorAll('.new-footwear-product__size-btn').forEach(function(btn) {
      var optIdx = parseInt(btn.getAttribute('data-option-index'), 10);
      var sizeVal = btn.getAttribute('data-value');
      var match = variants.find(function(v) {
        var sizeOk = v['option' + (optIdx + 1)] === sizeVal;
        var colorOk = (color == null || colorOptionIndex < 0) ? true
                    : v['option' + (colorOptionIndex + 1)] === color;
        return sizeOk && colorOk;
      });
      var soldOut = match ? (match.available === false) : false;
      btn.classList.toggle('new-footwear-product__size-btn--unavailable', soldOut);
      if (soldOut) { btn.setAttribute('aria-disabled', 'true'); btn.title = 'Sold out'; }
      else { btn.removeAttribute('aria-disabled'); btn.removeAttribute('title'); }
    });
  }

  /* ═══════════════════════════════════════════
     CART FUNCTIONS
     ═══════════════════════════════════════════ */
  /* ---- LOCKED RULE: size must be explicitly chosen before adding to cart ---- */
  function nfHideSizeError() {
    document.querySelectorAll('[data-size-error]').forEach(function(e) { e.hidden = true; });
    document.querySelectorAll('.new-footwear-product__option-values--error').forEach(function(w) {
      w.classList.remove('new-footwear-product__option-values--error');
    });
  }

  function nfRequireSize() {
    var sizeBtns = document.querySelectorAll('.new-footwear-product__size-btn');
    if (!sizeBtns.length) return true;
    var groups = {}, missingIdx = null;
    sizeBtns.forEach(function(b) { groups[b.getAttribute('data-option-index')] = true; });
    Object.keys(groups).forEach(function(idx) {
      if (missingIdx === null &&
          !document.querySelector('.new-footwear-product__size-btn--active[data-option-index="' + idx + '"]')) {
        missingIdx = idx;
      }
    });
    if (missingIdx === null) return true;
    var anyBtn = document.querySelector('.new-footwear-product__size-btn[data-option-index="' + missingIdx + '"]');
    var block = anyBtn ? anyBtn.closest('.new-footwear-product__option') : null;
    var err = block ? block.querySelector('[data-size-error]') : document.querySelector('[data-size-error]');
    var wrap = block ? block.querySelector('.new-footwear-product__option-values') : null;
    if (err) err.hidden = false;
    if (wrap) wrap.classList.add('new-footwear-product__option-values--error');
    var target = wrap || err;
    if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return false;
  }

  function addToCart(variantId, quantity) {
    if (!variantId) return;
    var body = JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] });
    if (atcBtn) atcBtn.disabled = true;
    if (atcText) atcText.textContent = 'Adding...';
    if (stickyAtc) { stickyAtc.disabled = true; stickyAtc.textContent = 'Adding...'; }

    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
      .then(function(r) { return r.json(); })
      .then(function() {
        openCartDrawer();
        refreshCartDrawer();
        updateCartCount();
        var currentVariant = variantSelect ? variantSelect.value : null;
        var v = currentVariant ? variants.find(function(vr) { return String(vr.id) === currentVariant; }) : null;
        if (atcBtn) atcBtn.disabled = false;
        if (atcText) atcText.textContent = v ? 'Add to Cart - ' + formatMoney(v.price) : 'Add to Cart';
        if (stickyAtc) { stickyAtc.disabled = false; stickyAtc.textContent = v ? 'Add to Cart - ' + formatMoney(v.price) : 'Add to Cart'; }
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
        if (atcBtn) atcBtn.disabled = false;
        if (atcText) atcText.textContent = 'Add to Cart';
        if (stickyAtc) { stickyAtc.disabled = false; stickyAtc.textContent = 'Add to Cart'; }
      });
  }

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.add('new-footwear-cart-drawer--open');
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = '-' + window.scrollY + 'px';
      cartDrawer.setAttribute('data-scroll-pos', window.scrollY);
    }
    if (cartOverlay) { cartOverlay.style.display = 'block'; cartOverlay.classList.add('new-footwear-cart-overlay--open'); }
  }

  function closeCartDrawer() {
    if (cartDrawer) {
      var scrollPos = parseInt(cartDrawer.getAttribute('data-scroll-pos') || '0', 10);
      cartDrawer.classList.remove('new-footwear-cart-drawer--open');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
      window.scrollTo(0, scrollPos);
    }
    if (cartOverlay) { cartOverlay.classList.remove('new-footwear-cart-overlay--open'); setTimeout(function() { cartOverlay.style.display = 'none'; }, 300); }
  }

  /* Site-wide handle so legacy per-PDP drawers can route into this one */
  window.CozyCartDrawer = { open: openCartDrawer, refresh: refreshCartDrawer };

  function refreshCartDrawer() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCartDrawer(cart); updateCartCount(cart.item_count); })
      .catch(function(err) { console.error('Cart fetch error:', err); });
  }

  /* FleeceSkin Tights (TA 2026-11-03): its colour option is named "Shade"; treat it as colour ONLY for this product. */
  var FSK_PRODUCT_ID = '15474803376218';
  var FSK_SHADE_CSS = { 'Black Sheer': '#5f4c41', 'Hazelnut': '#6e4a34', 'Caramel': '#844c31', 'Chocolate Brown': '#361a16' };
  function isFskId(id) { return String(id) === FSK_PRODUCT_ID; }

  /* Color name to CSS hex mapping */
  function cartColorToCSS(name) {
    var n = name.toLowerCase().replace(/[\s-]/g, '');
    var map = {
      'gold': '#D4AF37', 'rosegold': '#B76E79', 'silver': '#C0C0C0',
      'creamwhite': '#F1EAD8', 'darkgreen': '#2E4A3E', 'softpink': '#F2C7CF',
      'black': '#2B2B2D', 'white': '#FFFFFF', 'darkblue': '#2E3D5A', 'blue': '#4A90D9',
      'red': '#C0392B', 'green': '#27AE60', 'pink': '#E91E8C',
      'purple': '#8E44AD', 'yellow': '#F1C40F', 'orange': '#E67E22',
      'brown': '#8B4513', 'grey': '#808080', 'gray': '#808080',
      'navy': '#35476C', 'teal': '#008080', 'coral': '#FF7F50',
      'ivory': '#FFFFF0', 'beige': '#F5F5DC', 'champagne': '#F7E7CE',
      'platinum': '#E5E4E2', 'bronze': '#CD7F32', 'copper': '#B87333',
      'skyblue': '#87CEEB', 'darkpink': '#E75480', 'cream': '#FFFDD0',
      'burgundy': '#800020', 'maroon': '#800000', 'olive': '#808000',
      'khaki': '#C3B091', 'tan': '#D2B48C', 'lavender': '#E6E6FA',
      'aurora': '#78B159', 'midnight': '#191970', 'charcoal': '#36454F',
      'blush': '#DE5D83', 'blushpink': '#E0AFAC', 'mint': '#98FF98', 'rose': '#FF007F',
      'wine': '#722F37', 'sage': '#BCB88A', 'taupe': '#483C32',
      'leopard': 'linear-gradient(135deg, #b07a3f 0%, #c89559 50%, #d8a76a 100%)',
      'tortoise': 'linear-gradient(135deg, #8b4513 0%, #c89559 60%, #d8a76a 100%)',
      'tortoiseshell': 'linear-gradient(135deg, #8b4513 0%, #c89559 60%, #d8a76a 100%)',
      'cheetah': 'linear-gradient(135deg, #b88455 0%, #d5a26a 100%)',
      'animal': 'linear-gradient(135deg, #b07a3f 0%, #c89559 100%)',
      'strawberrymilk': '#F4B8C4', 'taroswirl': '#C9B3E8', 'blueberryboba': '#8FCDE8',
      'matchalatte': '#9FD18A', 'mangocream': '#F5D96B', 'cloudbluecord': '#A9C4E0',
      'sagegreencord': '#A8BE9E'
    };
    /* exact variant name wins before any substring match, so "Mango Cream" cannot
       resolve to 'cream' and "Sage Green Cord" cannot resolve to 'green' */
    if (map[n]) return map[n];
    /* longest match wins — "Blush Pink" must hit 'blushpink', not the 'pink' that
       appears earlier in the map (same for "Rose Gold" vs 'gold') */
    var found = null, bestLen = 0;
    Object.keys(map).forEach(function(key) {
      if (n.indexOf(key) !== -1 && key.length > bestLen) { found = map[key]; bestLen = key.length; }
    });
    return found || '#888888';
  }

  /* Line-item personalization properties from the last render, keyed by line key */
  var cozyLinePropsByKey = {};

  /* Product data cache for color swatches */
  var productDataCache = {};

  function fetchProductData(handle) {
    if (productDataCache[handle]) return Promise.resolve(productDataCache[handle]);
    return fetch('/products/' + handle + '.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var product = data.product;
        /* The public .json endpoint has NO per-variant `available` field, which made
           every size render as in-stock (sold-out swap then emptied the cart line).
           Merge real availability from the .js endpoint before caching. */
        return fetch('/products/' + handle + '.js')
          .then(function(r2) { return r2.ok ? r2.json() : null; })
          .then(function(jsP) {
            if (jsP && jsP.variants) {
              var availById = {};
              jsP.variants.forEach(function(v) { availById[String(v.id)] = v.available; });
              product.variants.forEach(function(v) {
                if (String(v.id) in availById) v.available = availById[String(v.id)];
              });
            }
            productDataCache[handle] = product;
            return product;
          })
          .catch(function() { productDataCache[handle] = product; return product; });
      });
  }

  function getColorOptionFromProduct(product) {
    if (!product.options) return null;
    var colorNames = ['color', 'colour', 'metal', 'finish', 'co'];
    if (isFskId(product.id)) colorNames = colorNames.concat(['shade']);
    for (var i = 0; i < product.options.length; i++) {
      var opt = product.options[i];
      if (colorNames.indexOf(opt.name.toLowerCase()) !== -1) return opt;
    }
    return null;
  }

  /* Find image URL for a given variant ID or color name from product data */
  function findImageForVariant(product, variantId, colorName) {
    if (!product || !product.images || !product.images.length) return null;
    /* Strategy 1: match by variant_ids on images */
    for (var i = 0; i < product.images.length; i++) {
      var img = product.images[i];
      if (img.variant_ids && img.variant_ids.length && img.variant_ids.indexOf(variantId) !== -1) {
        return img.src;
      }
    }
    /* Strategy 2: match by color name in filename */
    if (colorName) {
      var colorLower = colorName.toLowerCase();
      for (var j = 0; j < product.images.length; j++) {
        var imgSrc = product.images[j].src || '';
        var filename = imgSrc.substring(imgSrc.lastIndexOf('/') + 1).split('?')[0].toLowerCase();
        if (filename.indexOf(colorLower) !== -1) {
          return product.images[j].src;
        }
      }
    }
    /* Strategy 3: match by alt text */
    if (colorName) {
      var cLower = colorName.toLowerCase();
      for (var k = 0; k < product.images.length; k++) {
        var alt = (product.images[k].alt || '').toLowerCase();
        if (alt && alt.indexOf(cLower) !== -1) {
          return product.images[k].src;
        }
      }
    }
    return null;
  }

  function renderCartDrawer(cart) {
    if (!cartLineItems) return;
    if (!cart.items || cart.items.length === 0) {
      cartLineItems.innerHTML = '';
      if (cartEmpty) cartEmpty.style.display = 'block';
      if (cartFooter) cartFooter.style.display = 'none';
      if (cartUpsells) cartUpsells.style.display = 'none';
      return;
    }
    if (cartEmpty) cartEmpty.style.display = 'none';
    if (cartFooter) cartFooter.style.display = 'block';

    /* Cart-driven trust wording: Personalized Name Necklace carries a Lifetime Warranty.
       When it's in the cart, show that everywhere; otherwise restore the page default. */
    try {
      var cozyHasNecklace = cart.items.some(function(it) { return it.product_id === 8042774724698; });
      var cozyTrustSpans = document.querySelectorAll('ROOT TRUSTCLS > span'.replace('ROOT','#new-footwear-cart-drawer').replace('TRUSTCLS','.new-footwear-cart-drawer__trust-row'));
      for (var cti = 0; cti < cozyTrustSpans.length; cti++) {
        var cozySp = cozyTrustSpans[cti];
        if (/Money Back|Lifetime Warranty/.test(cozySp.textContent)) {
          if (!cozySp.dataset.defaultTrust) cozySp.dataset.defaultTrust = (cozySp.textContent.indexOf('Lifetime') !== -1) ? 'Lifetime Warranty' : '30-Day Money Back';
          var cozyIcon = cozySp.querySelector('span');
          var cozyTxt = cozyHasNecklace ? 'Lifetime Warranty' : cozySp.dataset.defaultTrust;
          if (cozyIcon) cozySp.innerHTML = cozyIcon.outerHTML + ' ' + cozyTxt;
          break;
        }
      }
    } catch (cozyErr) {}

    /* Render items first without swatches, then fetch product data for colors */
    var html = '';
    var sizeNames = ['size', 'length', 'width'];
    /* Remember every line's personalization properties, keyed by line key, so a
       color/size swap in the drawer can carry them onto the replacement line. */
    cozyLinePropsByKey = {};
    cart.items.forEach(function(item, idx) {
      cozyLinePropsByKey[item.key] = item.properties || {};
      /* Get current color and size from options_with_values */
      var currentColor = '';
      var currentSize = '';
      var currentLetter = '';
      if (item.options_with_values) {
        for (var o = 0; o < item.options_with_values.length; o++) {
          var optName = item.options_with_values[o].name.toLowerCase();
          if (optName === 'color' || optName === 'colour' || optName === 'metal' || optName === 'finish' || optName === 'co' || (optName === 'shade' && isFskId(item.product_id))) {
            currentColor = item.options_with_values[o].value;
          }
          if (sizeNames.indexOf(optName) !== -1) {
            currentSize = item.options_with_values[o].value;
          }
          if (optName === 'letter' || optName === 'letters' || optName === 'initial') {
            currentLetter = item.options_with_values[o].value;
          }
        }
      }

      html += '<div class="new-footwear-cart-item" data-key="' + item.key + '" data-product-handle="' + item.handle + '" data-variant-id="' + item.variant_id + '" data-item-index="' + idx + '">';
      html += '<a href="/products/' + (item.handle || '') + '" class="new-footwear-cart-item__image-link" aria-label="View ' + item.title + '"><div class="new-footwear-cart-item__image"><img src="' + item.image + '" alt="' + item.title + '" width="80" height="100" loading="lazy"></div></a>';
      html += '<div class="new-footwear-cart-item__details">';
      var cozyIsBp = String(item.product_id) === '8106421256282';
      html += '<a href="/products/' + (item.handle || '') + '" class="new-footwear-cart-item__title-link" style="color:inherit;text-decoration:none;"><p class="new-footwear-cart-item__title"' + (cozyIsBp ? ' style="font-size:16px!important;font-weight:800!important;line-height:1.25"' : '') + '>' + item.product_title + '</p></a>';
      /* Color label + swatches placeholder */
      if (currentColor && !cozyIsBp) {
        html += '<div class="new-footwear-cart-item__color-row">';
        html += '<span class="new-footwear-cart-item__color-label">' + (isFskId(item.product_id) ? 'Shade' : 'Color') + ': <strong class="new-footwear-cart-item__color-name">' + currentColor + '</strong></span>';
        html += '<div class="new-footwear-cart-item__swatches" data-item-key="' + item.key + '"></div>';
        html += '</div>';
      } else if (!currentSize && item.variant_title) {
        html += '<p class="new-footwear-cart-item__variant">' + item.variant_title + '</p>';
      }
      /* Letter option (Heart Initial etc.) — the selected letter must stay visible in the cart */
      if (currentLetter) {
        html += '<div class="new-footwear-cart-item__size-row new-footwear-cart-item__letter-row">';
        html += '<span class="new-footwear-cart-item__size-label">Letter: <strong class="new-footwear-cart-item__size-name">' + currentLetter + '</strong></span>';
        html += '</div>';
      }
      /* Personalized Name Backpack: custom details block (lettering, wool w/ ball, charms, exact name), size row last, no color swatches */
      if (cozyIsBp) {
        var bpP = item.properties || {}, bpE = function (s) { return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); };
        var bpCode = String(bpP._wool_code || ''), bpIsMix = bpCode.indexOf('+') > -1, bpWool = String(bpP['Wool Color'] || '');
        var bpYarn = (window.cozyBpYarnUrl && !bpIsMix && bpCode) ? '<img class="bp-cart__ball" src="' + window.cozyBpYarnUrl.replace('{code}', bpCode) + '" alt="">' : '';
        var bpMixName = bpIsMix ? bpWool.replace(/^Mix of colors\s*[·\-]?\s*/i,'').replace(/\s*\(.*$/,'') : '';
        var bpWoolHtml = bpIsMix ? '&#127752; <strong>Mix of colors</strong> &middot; ' + bpE(bpMixName) + ' <span class="bp-cart__code">' + bpE(bpCode.split('+').join(' + ')) + '</span>'
                                 : bpYarn + '<strong>' + bpE(bpWool.replace(/\s*\(.*$/,'')) + '</strong>' + (bpCode ? ' <span class="bp-cart__code">' + bpE(bpCode) + '</span>' : '');
        html += '<div class="bp-cart">';
        var bpBag = bpP['Backpack Color'] || currentColor || '';
        if (bpBag) html += '<span class="bp-cart__row">Bag: <strong>' + bpE(bpBag) + '</strong></span>';
        if (bpP['Lettering']) html += '<span class="bp-cart__row">Lettering: <strong>' + bpE(bpP['Lettering']) + '</strong>' + (bpP._font_code ? ' <span class="bp-cart__code">' + bpE(bpP._font_code) + '</span>' : '') + '</span>';
        html += '<span class="bp-cart__row bp-cart__wool">Wool: ' + bpWoolHtml + '</span>';
        if (bpP['Charms']) html += '<span class="bp-cart__row">Charms: <strong>' + bpE(bpP['Charms']) + '</strong>' + (bpP._charm_codes ? ' <span class="bp-cart__code">' + bpE(bpP._charm_codes) + '</span>' : '') + '</span>';
        html += '<span class="bp-cart__row bp-cart__name">Name: <strong>' + bpE(bpP['Name'] || '') + '</strong></span>';
        html += '</div>';
      }
      /* Size label + placeholder for interactive size buttons */
      if (currentSize) {
        html += '<div class="new-footwear-cart-item__size-row">';
        html += '<span class="new-footwear-cart-item__size-label">Size: <strong class="new-footwear-cart-item__size-name">' + currentSize + '</strong></span>';
        /* backpack rows: size is static text only (no in-drawer size switching, 2026-09-04) */
        if (!cozyIsBp) html += '<div class="new-footwear-cart-item__sizes" data-item-key="' + item.key + '"></div>';
        html += '</div>';
      }
      /* Personalization properties (e.g. engraved names) — generic; skips _private keys */
      if (item.properties && !cozyIsBp) {
        var fnEsc = function (s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); };
        var fnPropHtml = '';
        for (var fnPk in item.properties) {
          if (!Object.prototype.hasOwnProperty.call(item.properties, fnPk)) continue;
          if (fnPk.charAt(0) === '_') continue;
          if (!item.properties[fnPk]) continue;
          fnPropHtml += '<span class="new-footwear-cart-item__prop">' + fnEsc(fnPk) + ': <strong>' + fnEsc(item.properties[fnPk]) + '</strong></span>';
        }
        if (fnPropHtml) html += '<div class="new-footwear-cart-item__props">' + fnPropHtml + '</div>';
      }
      /* Show FREE + crossed-out original price when this line item has been
         fully discounted to $0 (e.g., BOGO 2nd pair). Otherwise show normal price. */
      if (item.final_line_price === 0 && item.original_line_price > 0) {
        html += '<p class="new-footwear-cart-item__price new-footwear-cart-item__price--free">' +
                '<s class="new-footwear-cart-item__price-strike">' + formatMoney(item.original_line_price) + '</s> ' +
                '<span class="new-footwear-cart-item__price-free">FREE</span>' +
                '</p>';
      } else {
        html += '<p class="new-footwear-cart-item__price">' + formatMoney(item.final_line_price) + '</p>';
      }
      /* 🔒 BOGO 2026-09-06: Shopify automatic discount "Buy 1, Get 1 20% Off" (necklace). When a line carries
         a line-level discount, name it under the price so the shopper sees WHICH necklace got the 20%. */
      if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
        var cozyDiscAmt = 0, cozyDiscTitle = '';
        item.line_level_discount_allocations.forEach(function(da){ cozyDiscAmt += (da.amount || 0); if (!cozyDiscTitle && da.discount_application) cozyDiscTitle = da.discount_application.title || ''; });
        if (cozyDiscAmt > 0) html += '<p class="cozy-line-disc" style="margin:2px 0 0;font-size:12px;font-weight:700;color:#2E7D4F;">&#127873; ' + String(cozyDiscTitle).replace(/</g,'&lt;') + ' (&#8722;' + formatMoney(cozyDiscAmt) + ')</p>';
      }
      /* Personalized Name Necklace: a quantity stepper would just clone the SAME
         engraved name, so swap it for "Add another necklace" which closes the
         drawer and sends them back to the page to configure a fresh one. */
      var cozyIsPersonalized = String(item.product_id) === '8042774724698' || cozyIsBp;
      /* Bundle set lines (hidden _set property) are one-per-set by design — no stepper. */
      var cozyIsSetLine = !!(item.properties && item.properties._set);
      /* FleeceSkin (TA 2026-11-03): no +/- stepper; an "Add another pair" link sends them back to the page instead. */
      var cozyIsFsk = isFskId(item.product_id);
      html += '<div class="new-footwear-cart-item__bottom-row">';
      if (!cozyIsPersonalized && !cozyIsSetLine && !cozyIsFsk) {
        html += '<div class="new-footwear-cart-item__qty">';
        html += '<button class="new-footwear-cart-item__qty-btn" data-action="decrease" data-key="' + item.key + '">&#8722;</button>';
        html += '<span class="new-footwear-cart-item__qty-value">' + item.quantity + '</span>';
        html += '<button class="new-footwear-cart-item__qty-btn" data-action="increase" data-key="' + item.key + '">+</button>';
        html += '</div>';
      } else {
        html += '<span class="new-footwear-cart-item__qty-static">Qty ' + item.quantity + '</span>';
      }
      html += '<button class="new-footwear-cart-item__remove" data-action="remove" data-key="' + item.key + '">Remove</button>';
      html += '</div>';
      if (cozyIsBp) {
        var bpUrl = '/products/' + (item.handle || 'personalized-name-knitted-backpack');
        html += '<div class="bp-cart__actions"><button type="button" class="new-footwear-cart-item__add-another bp-cart__edit" data-action="edit-backpack" data-key="' + item.key + '" data-url="' + bpUrl + '?edit=' + encodeURIComponent(item.key) + '">&#9998; Edit this bag</button>';
        html += '<button type="button" class="new-footwear-cart-item__add-another" data-action="add-another-backpack" data-key="' + item.key + '" data-url="' + bpUrl + '?new=1">&#43; Add another bag</button></div>';
      } else if (cozyIsPersonalized) {
        html += '<button type="button" class="new-footwear-cart-item__add-another" data-action="add-another-necklace" data-key="' + item.key + '" data-url="/products/personalized-name-necklace">&#43; Add a 2nd necklace &middot; 25% off</button>';
      } else if (cozyIsFsk) {
        html += '<button type="button" class="new-footwear-cart-item__add-another" data-action="add-another-fsk" data-key="' + item.key + '" data-url="/products/' + (item.handle || 'fleeceskin-fleece-lined-tights') + '">&#43; Add another pair</button>';
      }
      html += '</div></div>';
    });
    cartLineItems.innerHTML = html;
    if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price); cozyRenderSavings(cart); cozyEnhanceComparePrices(cart);

    /* Now fetch product data and populate color swatches */
    cart.items.forEach(function(item) {
      if (!item.handle) return;
      var swatchContainer = cartLineItems.querySelector('.new-footwear-cart-item__swatches[data-item-key="' + item.key + '"]');
      /* NOTE: do NOT early-return when swatchContainer is missing — we still need to populate size buttons for color-less products */

      fetchProductData(item.handle).then(function(product) {
        var colorOpt = getColorOptionFromProduct(product);
        var hasColor = colorOpt && colorOpt.values && colorOpt.values.length >= 2;
        if (!hasColor && swatchContainer) {
          swatchContainer.style.display = 'none';
        }

        /* Find current color value */
        var currentColor = '';
        if (item.options_with_values) {
          for (var o = 0; o < item.options_with_values.length; o++) {
            var optName = item.options_with_values[o].name.toLowerCase();
            if (optName === 'color' || optName === 'colour' || optName === 'metal' || optName === 'finish' || (optName === 'shade' && isFskId(item.product_id))) {
              currentColor = item.options_with_values[o].value;
              break;
            }
          }
        }

        if (hasColor && swatchContainer) {
        var colorPosition = colorOpt.position;
        var swatchHtml = colorOpt.values.map(function(colorVal) {
          var isActive = colorVal.toLowerCase() === currentColor.toLowerCase();
          /* Match the new colour while preserving every OTHER option of this
             line's variant (size, number of names, ...) - a colour-only match
             lands on that colour's FIRST variant and silently swaps the line
             to a different size/price. Exact combo first; colour-only match
             only as a last-resort fallback. */
          var lineOpts = (item.options_with_values || []).map(function(ov) { return ov.value; });
          var matchVariant = null;
          var colorOnlyFallback = null;
          for (var v = 0; v < product.variants.length; v++) {
            var vr = product.variants[v];
            var vrColor = vr['option' + colorPosition];
            if (!vrColor || vrColor.toLowerCase() !== colorVal.toLowerCase()) continue;
            if (!colorOnlyFallback) colorOnlyFallback = vr;
            var othersMatch = true;
            for (var op = 1; op <= 3; op++) {
              if (op === colorPosition) continue;
              var lineVal = lineOpts[op - 1];
              if (lineVal == null) continue;
              var vrVal = vr['option' + op];
              if (String(vrVal == null ? '' : vrVal).toLowerCase() !== String(lineVal).toLowerCase()) { othersMatch = false; break; }
            }
            if (othersMatch) { matchVariant = vr; break; }
          }
          if (!matchVariant) matchVariant = colorOnlyFallback;
          /* 🔒 Sold-out colours are NOT offered in the drawer (TA 2026-09-01).
             A swap removes the line first and re-adds it; if the target variant
             is unavailable the re-add 422s and the item VANISHES from the cart.
             Availability-driven, never hardcoded — a restock restores it. */
          if (!matchVariant || matchVariant.available === false) return '';
          var vid = matchVariant ? matchVariant.id : '';
          return '<button class="new-footwear-cart-item__swatch' + (isActive ? ' new-footwear-cart-item__swatch--active' : '') + '" ' +
            'style="background:' + ((isFskId(item.product_id) && FSK_SHADE_CSS[colorVal]) || cartColorToCSS(colorVal)) + '" ' +
            'title="' + colorVal + '" ' +
            'data-color="' + colorVal + '" ' +
            'data-variant-id="' + vid + '" ' +
            'data-item-key="' + item.key + '" ' +
            'data-quantity="' + item.quantity + '"' +
            '></button>';
        }).join('');
        swatchContainer.innerHTML = swatchHtml;
        } /* end if (hasColor) */

        /* Populate size buttons for this cart item (runs whether or not colors exist) */
        var sizeContainer = cartLineItems.querySelector('.new-footwear-cart-item__sizes[data-item-key="' + item.key + '"]');
        if (sizeContainer) {
          var sizeOpt = null;
          var sizeNamesList = ['size', 'length', 'width'];
          if (product.options) {
            for (var soIdx = 0; soIdx < product.options.length; soIdx++) {
              var soName = typeof product.options[soIdx] === 'string' ? product.options[soIdx] : (product.options[soIdx].name || '');
              if (sizeNamesList.indexOf(soName.toLowerCase()) !== -1) { sizeOpt = product.options[soIdx]; break; }
            }
          }
          if (sizeOpt && sizeOpt.values && sizeOpt.values.length >= 2) {
            var sizePos = sizeOpt.position;
            var currentSizeVal = '';
            if (item.options_with_values) {
              for (var ow = 0; ow < item.options_with_values.length; ow++) {
                if (sizeNamesList.indexOf(item.options_with_values[ow].name.toLowerCase()) !== -1) {
                  currentSizeVal = item.options_with_values[ow].value;
                  break;
                }
              }
            }
            /* Re-resolve colorOpt + currentColorVal in this scope so size buttons render
               correctly even if the swatch block didn't run for this item. */
            var localColorOpt = (typeof colorOpt !== 'undefined' && colorOpt) ? colorOpt : getColorOptionFromProduct(product);
            var currentColorVal = '';
            if (item.options_with_values) {
              var colorNamesLocal = ['color', 'colour', 'metal', 'finish'];
              if (isFskId(item.product_id)) colorNamesLocal.push('shade'); /* keep the chosen FleeceSkin shade when switching size */
              for (var ow2 = 0; ow2 < item.options_with_values.length; ow2++) {
                if (colorNamesLocal.indexOf(item.options_with_values[ow2].name.toLowerCase()) !== -1) {
                  currentColorVal = item.options_with_values[ow2].value;
                  break;
                }
              }
            }
            var sizeBtnHtml = sizeOpt.values.map(function(sv) {
              var svStr = typeof sv === 'object' ? (sv.value || sv.name || String(sv)) : String(sv);
              var isActiveSize = svStr.toLowerCase() === currentSizeVal.toLowerCase();
              /* Find matching variant: same color (if applicable), this size */
              var matchV = null;
              for (var vv = 0; vv < product.variants.length; vv++) {
                var variant = product.variants[vv];
                var sizeMatch = variant['option' + sizePos] && String(variant['option' + sizePos]).toLowerCase() === svStr.toLowerCase();
                var colorMatch = true;
                if (localColorOpt && currentColorVal) {
                  var cPos = localColorOpt.position;
                  colorMatch = variant['option' + cPos] && String(variant['option' + cPos]).toLowerCase() === currentColorVal.toLowerCase();
                }
                if (sizeMatch && colorMatch) { matchV = variant; break; }
              }
              /* Fallback: if no color match, try matching by size only (saves the cart from showing all sold-out) */
              if (!matchV) {
                for (var vv2 = 0; vv2 < product.variants.length; vv2++) {
                  var variant2 = product.variants[vv2];
                  if (variant2['option' + sizePos] && String(variant2['option' + sizePos]).toLowerCase() === svStr.toLowerCase()) {
                    matchV = variant2;
                    break;
                  }
                }
              }
              var svid = matchV ? matchV.id : '';
              /* Trust matchV.available — if Shopify says it's available, render as such.
                 Default to TRUE when we have a variant match but `available` is undefined
                 (some products with inventory_management=null report differently). */
              var avail = matchV ? (matchV.available !== false) : false;
              return '<button class="new-footwear-cart-item__size-btn' + (isActiveSize ? ' new-footwear-cart-item__size-btn--active' : '') + (avail ? '' : ' new-footwear-cart-item__size-btn--soldout') + '" ' +
                'data-size="' + svStr + '" ' +
                'data-variant-id="' + svid + '" ' +
                'data-item-key="' + item.key + '" ' +
                'data-quantity="' + item.quantity + '"' +
                (avail ? '' : ' disabled') +
                '>' + svStr + '</button>';
            }).join('');
            sizeContainer.innerHTML = sizeBtnHtml;
          } else {
            sizeContainer.style.display = 'none';
          }
        }

        /* Fix image to match current color (cart API may return default image) */
        if (currentColor && swatchContainer) {
          var variantId = parseInt(item.variant_id, 10);
          var correctSrc = findImageForVariant(product, variantId, currentColor);
          if (correctSrc) {
            var cartItemEl = swatchContainer.closest('.new-footwear-cart-item');
            if (cartItemEl) {
              var imgEl = cartItemEl.querySelector('.new-footwear-cart-item__image img');
              if (imgEl) imgEl.src = correctSrc.replace(/(\.\w+)(\?.*)?$/, '_200x$1');
            }
          }
        }
      });
    });

    /* Load upsells based on first cart item's product */
    var firstProductId = cart.items[0].product_id;
    loadCartUpsells(firstProductId, cart.items);
  }

  var lastUpsellCartKey = null;
  /* PIN: SoftFlow Drift Set is pinned as the first cart upsell when cart contains these products */
  var pinDriftSetForCartProductIds = { 7888000548954: true, 7878486589530: true }; /* CloudFlow Pants, SoftFlow Lounge Set */
  var driftSetPinnedHandle = 'softflow-drift-set';
  var driftSetPinnedProductId = 7888881942618;

  /* PIN: SoftFlow Lounge Set is pinned as slot #1 ONLY when SoftFlow Drift Set is in the cart.
     Slot #2 then rotates from the shuffled pool below (curated list or pajamas fallback).
     Skipped if Lounge Set itself is already in the cart. */
  var pinLoungeSetForCartProductIds = { 7888881942618: true }; /* SoftFlow Drift Set */
  var loungeSetPinnedHandle = 'softflow-lounge-set';
  var loungeSetPinnedProductId = 7878486589530;

  /* Fixed chain-length display + auto line-item property for specific upsell products */
  var upsellFixedLengthByHandle = { 'heart-initial-necklace': '45 cm (18\u2033)' };

  /* CURATED upsell lists per product in cart — when set, these REPLACE the pajamas-collection fetch.
     Order matters: shuffled then sliced. Mirrors the new-footwear-recommendations curation. */
  var curatedCartUpsellsByProductId = {
    /* Personalized Name Backpack: cart drawer shows ONLY the kids water bottle + Bobapop pencil case */
    8106421256282: ['my-bottle-me-personalized-kids-water-bottle', 'bobapop-pencil-case'],
    /* CloudFlow Pants: SoftFlow Drift Set is pinned via the existing rule above; these are the rest */
    7888000548954: ['luna-bloom-dress', 'sienna-sunset-dress', 'cloudease-lounge-set'],
    /* CloudEase Slip-Ons: cart drawer locked to CloudStep Shoes + Love Slippers ONLY */
    7917675741274: ['cloudstep-shoes', 'love-slippers'],
    /* Sorella Bow Sandals: cart drawer locked to CloudStep Shoes + Bella Bow Heels ONLY */
    7916014075994: ['cloudstep-shoes', 'bella-bow-heels'],
    /* Sienna Wedge Slip-Ons: cart drawer locked to Sorella Bow Sandals ONLY */
    7936078577754: ['sorella-bow-sandals'],
    /* Cloudstep Comfort Sandal: cart drawer locked to Sienna Wedge Slip-Ons ONLY */
    7999136825434: ['sienna-wedge-slip-ons'],
    /* Bella Breeze Maxi Dress: cart drawer shows ONLY Sienna Wedge Slip-Ons */
    7977325396058: ['sienna-wedge-slip-ons'],
    /* Pink Cowgirl PJ Set: cart drawer shows ONLY Pickle Lover + Ribbon Dreams pajama sets */
    8000682098778: ['pickle-lover-pajama-set', 'ribbon-dreams-pajama-set'],
    /* Personalized Name Necklace: Heart Initial first, then Sparkle Initial (TA 2026-10-27) */
    8042774724698: ['heart-initial-necklace'],
    /* Flower Name Necklace: Heart Initial first, then Sparkle Initial (TA 2026-10-27) */
    8136792375386: ['heart-initial-necklace'],
    /* Family Tree Necklace: Heart Initial first, then Sparkle Initial (TA 2026-10-27, Family Tree cart only) */
    8169499263066: ['heart-initial-necklace'],
    /* Sparkle Initial Necklace (2026-10-27, TA): show the Heart Initial on these pages too, not shoes */
    15445306605658: ['heart-initial-necklace'],
    /* ChillClip Wearable Fan: cart drawer locked to Arctic Mist Cooling Fan ONLY */
    8045226524762: ['arctic-mist-cooling-fan'],
    /* Miso Cozy Pajama Set: cart drawer shows ONLY Pink Cowgirl PJ Set */
    8057151455322: ['pink-cowgirl-pj-set'],
    /* Cozy Cloud Slippers: cart drawer locked to CloudComfort Slippers Women ONLY (TA 8/12) */
    8051604422746: ['cloudcomfort-women'],
    /* SculptFlow Bodysuit: cart drawer locked to SoftFlow Lounge Set ONLY (TA 8/13) */
    8058471579738: ['softflow-lounge-set']
  };

  function fetchProductByHandleForCart(handle) {
    return fetch('/products/' + handle + '.json')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(d) { return d && d.product ? d.product : null; })
      .catch(function() { return null; });
  }

  function fetchPinnedDriftSet(cartProductIds) {
    var shouldPin = false;
    for (var i = 0; i < cartProductIds.length; i++) {
      if (pinDriftSetForCartProductIds[cartProductIds[i]]) { shouldPin = true; break; }
    }
    /* Don't pin if drift set already in cart */
    if (cartProductIds.indexOf(driftSetPinnedProductId) !== -1) shouldPin = false;
    if (!shouldPin) return Promise.resolve(null);
    return fetchProductByHandleForCart(driftSetPinnedHandle);
  }

  function fetchPinnedLoungeSet(cartProductIds) {
    /* Pin Lounge Set ONLY when one of the trigger products is in the cart (e.g., Drift Set) */
    var shouldPin = false;
    for (var i = 0; i < cartProductIds.length; i++) {
      if (pinLoungeSetForCartProductIds[cartProductIds[i]]) { shouldPin = true; break; }
    }
    if (cartProductIds.indexOf(loungeSetPinnedProductId) !== -1) shouldPin = false;
    if (!shouldPin) return Promise.resolve(null);
    return fetchProductByHandleForCart(loungeSetPinnedHandle);
  }

  /* 2026-10-27 (TA): with these products in the cart the curated recs keep their listed order (no shuffle) */
  var curatedFixedOrderForProductIds = { 8169499263066: true, 8042774724698: true, 8136792375386: true };
  /* Sparkle Initial drawer card: letter|finish -> photo, filled while rendering */
  var skdImgMap = {};

  function fetchCuratedCartListIfDefined(cartProductIds) {
    /* Use the first matching cart product's curated list */
    var handles = null;
    for (var i = 0; i < cartProductIds.length; i++) {
      if (curatedCartUpsellsByProductId[cartProductIds[i]]) {
        handles = curatedCartUpsellsByProductId[cartProductIds[i]];
        break;
      }
    }
    if (!handles || handles.length === 0) return Promise.resolve(null);
    return Promise.all(handles.map(fetchProductByHandleForCart)).then(function(arr) {
      return arr.filter(function(p) { return p; });
    });
  }

  /* Cart-driven upsell suppression: with any of these products in the cart the
     "Recommended for You" block is hidden entirely (nothing related to show yet).
     Keep this map identical in apparel-product.js AND new-footwear-product.js. */
  var suppressCartUpsellsForProductIds = {
    8083649298522: true, /* BobaPop Pencil Case */
    15474803376218: true /* FleeceSkin Tights (TA 11/3: no recs until he picks one) */
  };

  function loadCartUpsells(productId, cartItems, forceReload) {
    if (!cartUpsells || !cartUpsellItems) return;
    /* Build a stable cache key from cart product IDs so we skip re-render when cart hasn't changed */
    var cartProductIds = cartItems.map(function(item) { return item.product_id; });
    for (var su = 0; su < cartProductIds.length; su++) {
      if (suppressCartUpsellsForProductIds[cartProductIds[su]]) {
        cartUpsells.style.display = 'none';
        lastUpsellCartKey = null;
        return;
      }
    }
    var cacheKey = cartProductIds.sort().join(',');
    if (!forceReload && lastUpsellCartKey === cacheKey && cartUpsells.style.display === 'block') return;
    lastUpsellCartKey = cacheKey;
    /* Fetch in parallel: pajamas (fallback), curated list (override), pinned drift set, pinned lounge set */
    Promise.all([
      fetch('/collections/footwear/products.json?limit=20').then(function(r) { return r.json(); }),
      fetchPinnedDriftSet(cartProductIds),
      fetchCuratedCartListIfDefined(cartProductIds),
      fetchPinnedLoungeSet(cartProductIds)
    ])
      .then(function(results) {
        var data = results[0];
        var pinnedDriftSet = results[1];
        var curated = results[2];
        var pinnedLoungeSet = results[3];

        /* If a curated list is defined for any cart product, use it instead of pajamas */
        var sourceProducts;
        if (curated && curated.length > 0) {
          sourceProducts = curated;
        } else if (data && data.products) {
          sourceProducts = data.products;
        } else {
          sourceProducts = [];
        }

        if (sourceProducts.length === 0 && !pinnedDriftSet && !pinnedLoungeSet) {
          cartUpsells.style.display = 'none';
          return;
        }
        /* Filter out products already in cart, the pinned drift set, and the pinned lounge set */
        var upsellProducts = sourceProducts.filter(function(p) {
          if (cartProductIds.indexOf(p.id) !== -1) return false;
          if (pinnedDriftSet && p.id === pinnedDriftSet.id) return false;
          if (pinnedLoungeSet && p.id === pinnedLoungeSet.id) return false;
          return true;
        });
        /* Shuffle so slot #2 rotates each time the drawer opens (skipped for fixed-order carts) */
        var keepCuratedOrder = cartProductIds.some(function(cid) { return curatedFixedOrderForProductIds[cid]; });
        for (var si = keepCuratedOrder ? 0 : upsellProducts.length - 1; si > 0; si--) {
          var ri = Math.floor(Math.random() * (si + 1));
          var tmp = upsellProducts[si];
          upsellProducts[si] = upsellProducts[ri];
          upsellProducts[ri] = tmp;
        }
        /* Build final list (cap at 2): Lounge Set #1 always (when not in cart),
           then Drift Set or rotating shuffled product as #2 */
        var finalUpsells = [];
        if (pinnedLoungeSet) finalUpsells.push(pinnedLoungeSet);
        if (finalUpsells.length < 2 && pinnedDriftSet) finalUpsells.push(pinnedDriftSet);
        while (finalUpsells.length < 2 && upsellProducts.length > 0) {
          finalUpsells.push(upsellProducts.shift());
        }
        upsellProducts = finalUpsells;

        if (upsellProducts.length === 0) {
          cartUpsells.style.display = 'none';
          return;
        }

        var html = '';
        upsellProducts.forEach(function(p, pIdx) {
          var rawImg = p.featured_image || (p.images && p.images.length ? p.images[0].src : '') || '';
          var imgSrc = rawImg ? rawImg.replace(/(\.\w+)(\?.*)?$/, '_200x$1$2') : '';
          /* Collection API returns price as string on variants, recommendations API returns cents on product */
          var firstVariant = p.variants && p.variants.length ? p.variants[0] : null;
          var priceCents = p.price || (firstVariant ? Math.round(parseFloat(firstVariant.price) * 100) : 0);
          var compareCents = p.compare_at_price || (firstVariant && firstVariant.compare_at_price ? Math.round(parseFloat(firstVariant.compare_at_price) * 100) : 0);
          var price = priceCents ? formatMoney(priceCents) : '';
          var comparePrice = compareCents && compareCents > priceCents ? '<span class="new-footwear-cart-upsell__compare">' + formatMoney(compareCents) + '</span>' : '';
          var variantId = firstVariant ? firstVariant.id : '';

          /* Get color options from collection/recommendations data */
          var colorOpt = null;
          var colorNames = ['color', 'colour', 'metal', 'finish', 'co'];
          if (p.options) {
            for (var oi = 0; oi < p.options.length; oi++) {
              var opt = p.options[oi];
              var optName = typeof opt === 'string' ? opt : (opt.name || '');
              if (colorNames.indexOf(optName.toLowerCase()) !== -1) { colorOpt = opt; break; }
            }
          }
          var colorValues = [];
          if (colorOpt) {
            if (Array.isArray(colorOpt.values)) {
              colorValues = colorOpt.values.map(function(v) { return typeof v === 'object' ? (v.value || v.name || String(v)) : String(v); });
            }
          }
          var colorPosition = colorOpt ? (colorOpt.position || 1) : 1;
          /* 🔒 Upsell: never offer a colour with no purchasable variant (TA 2026-09-01). */
          if (p.variants && colorValues.length) {
            colorValues = colorValues.filter(function(cv) {
              for (var av = 0; av < p.variants.length; av++) {
                var avv = p.variants[av];
                var avc = avv['option' + colorPosition];
                if (avc && String(avc).toLowerCase() === String(cv).toLowerCase() && avv.available !== false) return true;
              }
              return false;
            });
          }

          /* Build color swatches HTML for upsell */
          var swatchHtml = '';
          if (colorValues.length >= 2) {
            swatchHtml = '<div class="new-footwear-cart-upsell__swatches">';
            swatchHtml += '<span class="new-footwear-cart-upsell__color-label">Color: <strong class="new-footwear-cart-upsell__color-name">' + colorValues[0] + '</strong></span>';
            swatchHtml += '<div class="new-footwear-cart-upsell__swatch-row">';
            colorValues.forEach(function(cv, si) {
              /* Find variant for this color */
              var matchVid = variantId;
              if (p.variants) {
                for (var vi = 0; vi < p.variants.length; vi++) {
                  if (p.variants[vi]['option' + colorPosition] && p.variants[vi]['option' + colorPosition].toLowerCase() === cv.toLowerCase() && p.variants[vi].available !== false) {
                    matchVid = p.variants[vi].id;
                    break;
                  }
                }
              }
              swatchHtml += '<button class="new-footwear-cart-upsell__swatch' + (si === 0 ? ' new-footwear-cart-upsell__swatch--active' : '') + '" ' +
                'style="background:' + cartColorToCSS(cv) + '" ' +
                'title="' + cv + '" ' +
                'data-color="' + cv + '" ' +
                'data-variant-id="' + matchVid + '" ' +
                'data-upsell-index="' + pIdx + '" ' +
                'data-handle="' + (p.handle || '') + '"' +
                '></button>';
            });
            swatchHtml += '</div></div>';
          }

          /* Build size buttons HTML for upsell */
          var sizeOpt = null;
          var upsellSizeNames = ['size', 'shoe size', 'length', 'width'];
          if (p.options) {
            for (var si2 = 0; si2 < p.options.length; si2++) {
              var sOpt = p.options[si2];
              var sOptName = typeof sOpt === 'string' ? sOpt : (sOpt.name || '');
              if (upsellSizeNames.indexOf(sOptName.toLowerCase()) !== -1) { sizeOpt = sOpt; break; }
            }
          }
          var sizeValues = [];
          if (sizeOpt) {
            if (Array.isArray(sizeOpt.values)) {
              sizeValues = sizeOpt.values.map(function(v) { return typeof v === 'object' ? (v.value || v.name || String(v)) : String(v); });
            }
          }
          var sizePosition = sizeOpt ? (sizeOpt.position || 1) : 1;

          var sizeHtml = '';
          if (sizeValues.length >= 2) {
            sizeHtml = '<div class="new-footwear-cart-upsell__size-wrap">';
            sizeHtml += '<span class="new-footwear-cart-upsell__size-label">Size: <strong class="new-footwear-cart-upsell__size-name">' + sizeValues[0] + '</strong></span>';
            sizeHtml += '<div class="new-footwear-cart-upsell__sizes">';
            sizeValues.forEach(function(sv, si3) {
              sizeHtml += '<button class="new-footwear-cart-upsell__size-btn' + (si3 === 0 ? ' new-footwear-cart-upsell__size-btn--active' : '') + '" ' +
                'data-size="' + sv + '" ' +
                'data-size-position="' + sizePosition + '" ' +
                'data-upsell-index="' + pIdx + '">' + sv + '</button>';
            });
            sizeHtml += '</div></div>';
          }

          /* Letter/initial option (e.g. Heart Initial Necklace, 26 values): compact dropdown, not buttons */
          var letterOpt = null;
          var letterNames = ['letter', 'initial'];
          if (p.options) {
            for (var li0 = 0; li0 < p.options.length; li0++) {
              var lOpt = p.options[li0];
              var lOptName = typeof lOpt === 'string' ? lOpt : (lOpt.name || '');
              if (letterNames.indexOf(lOptName.toLowerCase()) !== -1) { letterOpt = lOpt; break; }
            }
          }
          var letterValues = [];
          if (letterOpt && Array.isArray(letterOpt.values)) {
            letterValues = letterOpt.values.map(function(v) { return typeof v === 'object' ? (v.value || v.name || String(v)) : String(v); });
          }
          var letterHtml = '';
          if (letterValues.length >= 2) {
            letterHtml = '<div class="new-footwear-cart-upsell__letter-wrap">';
            letterHtml += '<select class="new-footwear-cart-upsell__letter" aria-label="Choose your letter">';
            letterHtml += '<option value="" selected disabled>Choose your letter</option>';
            letterValues.forEach(function(lv2) {
              letterHtml += '<option value="' + lv2 + '">' + lv2 + '</option>';
            });
            letterHtml += '</select></div>';
          }
          var fixedLen = upsellFixedLengthByHandle[p.handle || ''];
          if (fixedLen) {
            letterHtml += '<div class="new-footwear-cart-upsell__fixed-len">Chain length: <strong>' + fixedLen + '</strong></div>';
          }

          /* 2026-10-27 (TA): Sparkle Initial card - finish must be chosen (no preselect), compact pills, letter, photo follows the choice */
          var skCard = (p.handle === 'sparkle-initial-necklace');
          if (skCard) {
            var skImgById = {};
            (p.images || []).forEach(function(im) { skImgById[im.id] = im.src; });
            skdImgMap = {};
            (p.variants || []).forEach(function(v) { var u = skImgById[v.image_id]; if (u) skdImgMap[v.option1 + '|' + v.option2] = u.replace(/(\.\w+)(\?.*)?$/, '_300x$1$2'); });
            if (!document.getElementById('skd-css')) { var skSt = document.createElement('style'); skSt.id = 'skd-css'; skSt.textContent = '.skd-step{margin-top:5px}.skd-step .new-footwear-cart-upsell__letter-wrap{margin-top:0}.skd-label{display:block;font-size:11.5px;color:#6b6156;margin-bottom:3px}.skd-label strong{color:#2E2A26}.skd-fin{display:flex;gap:6px;padding:2px;margin:-2px;border:1.5px solid transparent;border-radius:9px}.skd-fin.is-err{border-color:#BF2E35;background:#FFF5F5;animation:skdShake .3s}.skd-sw{display:inline-flex;align-items:center;gap:5px;padding:4px 10px;border:1.5px solid #E5DACB;border-radius:999px;background:#fff;font-family:inherit;font-weight:700;font-size:11.5px;line-height:1.2;color:#2E2A26;cursor:pointer}.skd-sw.is-on{border-color:#A3754B;background:#FBF6EC;box-shadow:0 0 0 1px #A3754B inset}.skd-dot{width:12px;height:12px;border-radius:50%;display:block;box-shadow:inset 0 0 0 1px rgba(0,0,0,.08)}.skd-dot--gold{background:radial-gradient(circle at 32% 28%,#F8E7B9,#E3B54E 55%,#C9942F)}.skd-dot--silver{background:radial-gradient(circle at 32% 28%,#fff,#D9DCDF 55%,#AEB3B8)}.skd-err{display:none;margin:3px 2px 0;font-size:11.5px;font-weight:700;color:#BF2E35}.skd-fin.is-err+.skd-err{display:block}.skd-thumb{display:block;width:60px;height:75px;border-radius:6px;overflow:hidden;flex-shrink:0;background:#F3EDE5}.skd-img{width:60px;height:75px;object-fit:cover;transform:scale(1.2);transform-origin:50% 62%;mix-blend-mode:multiply;display:block}.skd-new{display:inline-block;margin-left:6px;padding:1px 6px;border-radius:999px;background:#C25B72;color:#fff;font-size:9px;font-weight:800;letter-spacing:.06em;vertical-align:2px}@keyframes skdShake{0%,100%{transform:translateX(0)}25%{transform:translateX(-3px)}75%{transform:translateX(3px)}}'; document.head.appendChild(skSt); }
            swatchHtml = '<div class="skd-step"><span class="skd-label">1. Finish: <strong class="skd-fin-name">choose gold or silver</strong></span>' +
              '<div class="skd-fin"><button type="button" class="skd-sw" data-c="Gold"><i class="skd-dot skd-dot--gold"></i>Gold</button><button type="button" class="skd-sw" data-c="Silver"><i class="skd-dot skd-dot--silver"></i>Silver</button></div>' +
              '<p class="skd-err">Please choose gold or silver</p></div>';
            sizeHtml = '';
            letterHtml = '<div class="skd-step"><span class="skd-label">2. Letter</span>' + letterHtml + '</div>';
          }
          html += '<div class="new-footwear-cart-upsell" data-handle="' + (p.handle || '') + '" data-variants=\'' + JSON.stringify(
            (p.variants || []).map(function(v) { return { id: v.id, o1: v.option1, o2: v.option2, o3: v.option3 }; })
          ) + '\'>';
          html += '<div class="new-footwear-cart-upsell__top">';
          html += '<a class="new-footwear-cart-upsell__image-link" href="/products/' + (p.handle || '') + '" aria-label="View ' + p.title + '">';
          html += skCard ? '<span class="skd-thumb"><img class="skd-img" src="' + (skdImgMap['Gold|A'] || imgSrc) + '" alt="' + p.title + '" loading="lazy"></span>' : '<img class="new-footwear-cart-upsell__image" src="' + imgSrc + '" alt="' + p.title + '" width="60" height="75" loading="lazy">';
          html += '</a>';
          html += '<div class="new-footwear-cart-upsell__info">';
          html += '<a class="new-footwear-cart-upsell__title-link" href="/products/' + (p.handle || '') + '" style="color:inherit;text-decoration:none;">';
          html += '<p class="new-footwear-cart-upsell__title">' + p.title + (skCard ? '<span class="skd-new">NEW</span>' : '') + '</p>';
          html += '</a>';
          html += '<div class="new-footwear-cart-upsell__price-row">' + comparePrice + '<span class="new-footwear-cart-upsell__price">' + price + '</span></div>';
          html += swatchHtml;
          html += sizeHtml;
          html += letterHtml;
          html += '</div>';
          html += '</div>';
          html += '<button class="new-footwear-cart-upsell__add-btn" data-variant-id="' + variantId + '">Add to Cart</button>';
          html += '</div>';
        });
        cartUpsellItems.innerHTML = html;
        cartUpsells.style.display = 'block';

        /* Wire up upsell title/image link clicks: close the drawer first so the back button
           returns the customer to the previous page instead of re-opening the drawer */
        cartUpsellItems.querySelectorAll('.new-footwear-cart-upsell__title-link, .new-footwear-cart-upsell__image-link').forEach(function(link) {
          link.addEventListener('click', function() {
            if (typeof closeCartDrawer === 'function') closeCartDrawer();
          });
        });

        /* Sparkle Initial card wiring (2026-10-27): finish pills, red box, photo follows finish + letter */
        cartUpsellItems.querySelectorAll('.new-footwear-cart-upsell[data-handle="sparkle-initial-necklace"]').forEach(function(skc) {
          var skImgEl = skc.querySelector('.skd-img');
          var skSel = skc.querySelector('.new-footwear-cart-upsell__letter');
          function skPhoto() { var c = skc.getAttribute('data-sk-color') || 'Gold'; var l = (skSel && skSel.value) || 'A'; var u = skdImgMap[c + '|' + l]; if (skImgEl && u) skImgEl.src = u; }
          skc.querySelectorAll('.skd-sw').forEach(function(b) {
            b.addEventListener('click', function(e) {
              e.preventDefault(); e.stopPropagation();
              skc.setAttribute('data-sk-color', b.getAttribute('data-c'));
              skc.querySelectorAll('.skd-sw').forEach(function(x) { x.classList.toggle('is-on', x === b); });
              var nm = skc.querySelector('.skd-fin-name'); if (nm) nm.textContent = b.getAttribute('data-c');
              var fb = skc.querySelector('.skd-fin'); if (fb) fb.classList.remove('is-err');
              skPhoto();
            });
          });
          if (skSel) skSel.addEventListener('change', skPhoto);
        });

        /* Letter selects: clear error state on choose */
        cartUpsellItems.querySelectorAll('.new-footwear-cart-upsell__letter').forEach(function(sel) {
          sel.addEventListener('change', function() { sel.classList.remove('new-footwear-cart-upsell__letter--err'); });
        });

        /* Wire up upsell add buttons */
        cartUpsellItems.querySelectorAll('.new-footwear-cart-upsell__add-btn').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var vid = btn.getAttribute('data-variant-id');
            var letterCard = btn.closest('.new-footwear-cart-upsell');
            var letterSel = letterCard ? letterCard.querySelector('.new-footwear-cart-upsell__letter') : null;
            /* Sparkle Initial: finish required (red box), then letter; variant = finish + letter */
            if (letterCard && letterCard.getAttribute('data-handle') === 'sparkle-initial-necklace') {
              var skFin = letterCard.getAttribute('data-sk-color') || '';
              var skBox = letterCard.querySelector('.skd-fin');
              if (!skFin) { if (skBox) { skBox.classList.remove('is-err'); void skBox.offsetWidth; skBox.classList.add('is-err'); } return; }
              if (letterSel && !letterSel.value) { letterSel.classList.add('new-footwear-cart-upsell__letter--err'); letterSel.focus(); return; }
              var skVars = [];
              try { skVars = JSON.parse(letterCard.getAttribute('data-variants') || '[]'); } catch(e) {}
              vid = '';
              for (var skv = 0; skv < skVars.length; skv++) { if (skVars[skv].o1 === skFin && skVars[skv].o2 === letterSel.value) { vid = String(skVars[skv].id); break; } }
              letterSel = null;
            }
            if (letterSel) {
              if (!letterSel.value) {
                letterSel.classList.add('new-footwear-cart-upsell__letter--err');
                letterSel.focus();
                return;
              }
              var lVariants = [];
              try { lVariants = JSON.parse(letterCard.getAttribute('data-variants') || '[]'); } catch(e) {}
              for (var lvi = 0; lvi < lVariants.length; lvi++) {
                var lvv = lVariants[lvi];
                if ([lvv.o1, lvv.o2, lvv.o3].indexOf(letterSel.value) !== -1) { vid = String(lvv.id); break; }
              }
            }
            if (!vid) return;
            btn.disabled = true;
            btn.textContent = 'Adding...';
            var addPayload = { id: parseInt(vid, 10), quantity: 1 };
            var lenHandle = letterCard ? letterCard.getAttribute('data-handle') : '';
            if (lenHandle && upsellFixedLengthByHandle[lenHandle]) {
              addPayload.properties = { 'Chain Length': upsellFixedLengthByHandle[lenHandle] };
            }
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(addPayload)
            })
            .then(function(r) { return r.json(); })
            .then(function() {
              btn.textContent = 'Added!';
              refreshCartDrawer();
              updateCartCount();
              setTimeout(function() { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 1500);
            })
            .catch(function() { btn.textContent = 'Add to Cart'; btn.disabled = false; });
          });
        });

        /* Helper: find matching variant from stored variants data based on selected color + size */
        function findUpsellVariant(upsellCard) {
          var variants = [];
          try { variants = JSON.parse(upsellCard.getAttribute('data-variants') || '[]'); } catch(e) {}
          var activeSwatch = upsellCard.querySelector('.new-footwear-cart-upsell__swatch--active');
          var activeSize = upsellCard.querySelector('.new-footwear-cart-upsell__size-btn--active');
          var selectedColor = activeSwatch ? activeSwatch.getAttribute('data-color') : '';
          var selectedSize = activeSize ? activeSize.getAttribute('data-size') : '';

          /* Try to find exact match for color + size */
          for (var vi = 0; vi < variants.length; vi++) {
            var v = variants[vi];
            var opts = [v.o1, v.o2, v.o3].filter(Boolean).map(function(o) { return o.toLowerCase(); });
            var colorMatch = !selectedColor || opts.indexOf(selectedColor.toLowerCase()) !== -1;
            var sizeMatch = !selectedSize || opts.indexOf(selectedSize.toLowerCase()) !== -1;
            if (colorMatch && sizeMatch) return v.id;
          }
          /* Fallback: just color match */
          if (selectedColor) {
            for (var vi2 = 0; vi2 < variants.length; vi2++) {
              var v2 = variants[vi2];
              var opts2 = [v2.o1, v2.o2, v2.o3].filter(Boolean).map(function(o) { return o.toLowerCase(); });
              if (opts2.indexOf(selectedColor.toLowerCase()) !== -1) return v2.id;
            }
          }
          return variants.length ? variants[0].id : '';
        }

        /* Wire up upsell swatch clicks */
        cartUpsellItems.querySelectorAll('.new-footwear-cart-upsell__swatch').forEach(function(swatch) {
          swatch.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var newColor = swatch.getAttribute('data-color');
            var handle = swatch.getAttribute('data-handle');
            var upsellCard = swatch.closest('.new-footwear-cart-upsell');
            if (!upsellCard) return;

            /* Update active state */
            upsellCard.querySelectorAll('.new-footwear-cart-upsell__swatch').forEach(function(s) {
              s.classList.remove('new-footwear-cart-upsell__swatch--active');
            });
            swatch.classList.add('new-footwear-cart-upsell__swatch--active');

            /* Update color name label */
            var colorNameEl = upsellCard.querySelector('.new-footwear-cart-upsell__color-name');
            if (colorNameEl && newColor) colorNameEl.textContent = newColor;

            /* Find correct variant based on color + size selection */
            var matchedVid = findUpsellVariant(upsellCard);
            var addBtn = upsellCard.querySelector('.new-footwear-cart-upsell__add-btn');
            if (addBtn && matchedVid) addBtn.setAttribute('data-variant-id', matchedVid);

            /* Update the product image — preload to prevent flash */
            if (handle) {
              fetchProductData(handle).then(function(product) {
                var newImgSrc = findImageForVariant(product, parseInt(matchedVid, 10), newColor);
                if (newImgSrc) {
                  var imgEl = upsellCard.querySelector('.new-footwear-cart-upsell__image');
                  if (imgEl) {
                    var finalSrc = newImgSrc.replace(/(\.\w+)(\?.*)?$/, '_200x$1');
                    var preload = new Image();
                    preload.onload = function() { imgEl.src = finalSrc; };
                    preload.src = finalSrc;
                  }
                }
              });
            }
          });
        });

        /* Wire up upsell size button clicks */
        cartUpsellItems.querySelectorAll('.new-footwear-cart-upsell__size-btn').forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var upsellCard = btn.closest('.new-footwear-cart-upsell');
            if (!upsellCard) return;

            /* Update active state */
            upsellCard.querySelectorAll('.new-footwear-cart-upsell__size-btn').forEach(function(b) {
              b.classList.remove('new-footwear-cart-upsell__size-btn--active');
            });
            btn.classList.add('new-footwear-cart-upsell__size-btn--active');

            /* Update size name label */
            var sizeNameEl = upsellCard.querySelector('.new-footwear-cart-upsell__size-name');
            if (sizeNameEl) sizeNameEl.textContent = btn.getAttribute('data-size');

            /* Find correct variant based on color + size selection */
            var matchedVid = findUpsellVariant(upsellCard);
            var addBtnEl = upsellCard.querySelector('.new-footwear-cart-upsell__add-btn');
            if (addBtnEl && matchedVid) addBtnEl.setAttribute('data-variant-id', matchedVid);
          });
        });
      })
      .catch(function() {
        if (cartUpsells) cartUpsells.style.display = 'none';
      });
  }

  function handleCartItemClick(e) {
    /* Handle swatch click */
    var swatch = e.target.closest('.new-footwear-cart-item__swatch');
    if (swatch) {
      e.preventDefault();
      e.stopPropagation();
      handleCartSwatchClick(swatch);
      return;
    }

    /* Handle size button click */
    var sizeBtn = e.target.closest('.new-footwear-cart-item__size-btn');
    if (sizeBtn && !sizeBtn.disabled) {
      e.preventDefault();
      e.stopPropagation();
      handleCartSizeClick(sizeBtn);
      return;
    }

    var target = e.target.closest('[data-action]');
    if (!target) return;
    var action = target.getAttribute('data-action');
    var key = target.getAttribute('data-key');
    if (!key) return;
    if (action === 'edit-backpack' || action === 'add-another-backpack') {
      e.preventDefault(); var bpGo = target.getAttribute('data-url'); closeCartDrawer(); setTimeout(function () { window.location.href = bpGo; }, 150); return;
    }
    if (action === 'add-another-fsk') {
      e.preventDefault();
      var fskUrl = target.getAttribute('data-url') || '/products/fleeceskin-fleece-lined-tights';
      closeCartDrawer();
      if (window.location.pathname === fskUrl) {
        var fskTop = document.getElementById('ccsSwatches') || document.getElementById('ccs-top');
        if (fskTop) setTimeout(function() { fskTop.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 320);
      } else {
        window.location.href = fskUrl;
      }
      return;
    }
    if (action === 'add-another-necklace') {
      e.preventDefault();
      var cozyUrl = target.getAttribute('data-url') || '/products/personalized-name-necklace';
      closeCartDrawer();
      if (window.location.pathname === cozyUrl) {
        var cozyTop = document.getElementById('fn-top') || document.querySelector('.fn-counts');
        if (cozyTop) setTimeout(function() { cozyTop.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 320);
        /* 🔒 2026-09-06 (TA): clear the NAME fields only, so a second click + Add can't create an accidental
           duplicate of the first necklace. Color and length stay as chosen. Fires 'input' so the live preview clears. */
        document.querySelectorAll('#fnNameFields .fn-name-input').forEach(function(inp) {
          inp.value = '';
          inp.dispatchEvent(new Event('input', { bubbles: true }));
        });
      } else {
        window.location.href = cozyUrl;
      }
      return;
    }
    if (action === 'remove') updateCartItem(key, 0);
    else if (action === 'decrease') {
      var qtyEl = target.parentElement.querySelector('.new-footwear-cart-item__qty-value');
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      updateCartItem(key, Math.max(0, qty - 1));
    } else if (action === 'increase') {
      var qtyEl2 = target.parentElement.querySelector('.new-footwear-cart-item__qty-value');
      var qty2 = qtyEl2 ? parseInt(qtyEl2.textContent, 10) : 1;
      updateCartItem(key, qty2 + 1);
    }
  }

  var swatchSwapping = false;
  /* 🔒 STABLE LINE ORDER (TA 2026-08-11): a drawer swap must never visually
     re-order the cart or disturb the other lines. Shopify's add.js prepends
     re-added lines and RE-HASHES EVERY line key on any cart mutation, so after
     a swap we re-render the whole drawer (fresh keys on every line) but in the
     PRE-swap display order — lines matched by identity (variant + properties),
     with the swapped-in line inheriting the swapped-out line's slot. */
  function cozyLineIdentity(item) {
    return String(item.variant_id) + '|' + JSON.stringify(item.properties || {});
  }
  function cozyStableOrder(cart, prevIds, swapSlot) {
    if (!prevIds || !prevIds.length) return cart;
    var used = {}, slots = new Array(prevIds.length), leftovers = [];
    cart.items.forEach(function(it) {
      var id = cozyLineIdentity(it), idx = -1;
      for (var i = 0; i < prevIds.length; i++) {
        if (!used[i] && prevIds[i] === id) { idx = i; break; }
      }
      if (idx > -1) { used[idx] = true; slots[idx] = it; }
      else { leftovers.push(it); }
    });
    if (leftovers.length && swapSlot > -1 && !slots[swapSlot]) {
      slots[swapSlot] = leftovers.shift();
    }
    var ordered = [];
    slots.forEach(function(it) { if (it) ordered.push(it); });
    leftovers.forEach(function(it) { ordered.push(it); });
    if (ordered.length === cart.items.length) cart.items = ordered;
    return cart;
  }

  function handleCartSwatchClick(swatch) {
    /* Prevent double-tap / rapid clicks */
    if (swatchSwapping) return;

    var newVariantId = swatch.getAttribute('data-variant-id');
    var itemKey = swatch.getAttribute('data-item-key');
    var quantity = parseInt(swatch.getAttribute('data-quantity') || '1', 10);
    var newColor = swatch.getAttribute('data-color');
    if (!newVariantId || !itemKey) return;

    /* If clicking the already active swatch, do nothing */
    if (swatch.classList.contains('new-footwear-cart-item__swatch--active')) return;

    /* Lock to prevent duplicate operations */
    swatchSwapping = true;
    var cozyPrevIds = null, cozySwapSlot = -1;
    var cozyDisplayKeys = Array.prototype.map.call(document.querySelectorAll('.new-footwear-cart-item'), function(el) { return el.getAttribute('data-key'); });

    /* Update the color name label and image immediately */
    var cartItem = swatch.closest('.new-footwear-cart-item');
    if (cartItem) {
      var colorName = cartItem.querySelector('.new-footwear-cart-item__color-name');
      if (colorName && newColor) colorName.textContent = newColor;
      /* Update active swatch visually */
      cartItem.querySelectorAll('.new-footwear-cart-item__swatch').forEach(function(s) {
        s.classList.remove('new-footwear-cart-item__swatch--active');
      });
      swatch.classList.add('new-footwear-cart-item__swatch--active');

      /* Disable swatches during swap to prevent double-tap */
      cartItem.querySelectorAll('.new-footwear-cart-item__swatch').forEach(function(s) {
        s.style.pointerEvents = 'none';
      });

      /* Update the product image to match the selected color — preload to prevent flash */
      var handle = cartItem.getAttribute('data-product-handle');
      function swapCartItemImage(product) {
        var newImgSrc = findImageForVariant(product, parseInt(newVariantId, 10), newColor);
        if (newImgSrc) {
          var imgEl = cartItem.querySelector('.new-footwear-cart-item__image img');
          if (imgEl) {
            var finalSrc = newImgSrc.replace(/(\.\w+)(\?.*)?$/, '_200x$1');
            var preload = new Image();
            preload.onload = function() { imgEl.src = finalSrc; };
            preload.src = finalSrc;
          }
        }
      }
      if (handle && productDataCache[handle]) {
        swapCartItemImage(productDataCache[handle]);
      } else if (handle) {
        fetchProductData(handle).then(swapCartItemImage);
      }
    }

    /* Get the current variant ID from the cart item data attribute */
    var currentVariantId = cartItem ? cartItem.getAttribute('data-variant-id') : null;

    /* Personalization (engraved names, chain length) must survive the colour swap.
       Read it from the LIVE cart at swap time - any in-memory copy can go stale
       once a swap re-keys the line, and stale props ship a nameless necklace. */
    var cozyCarriedProps = cozyLinePropsByKey[itemKey] || {};
    var cozyHasProps = Object.keys(cozyCarriedProps).length > 0;

    /*
     * Use /cart/change.js to remove old variant first, then /cart/change.js
     * to set new variant quantity. Avoids /cart/add.js which triggers
     * Shopify Dawn's cart-notification interceptor and causes duplicates.
     */
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(function(liveCart) {
      for (var lc = 0; lc < liveCart.items.length; lc++) {
        if (liveCart.items[lc].key === itemKey) {
          cozyCarriedProps = liveCart.items[lc].properties || {};
          cozyHasProps = Object.keys(cozyCarriedProps).length > 0;
          break;
        }
      }
      /* Order must come from what the shopper SEES (the DOM), not the cart
         array — Shopify's array order diverges from the displayed order after
         the first stable-ordered render. */
      var cozyIdByKey = {};
      liveCart.items.forEach(function(ci) { cozyIdByKey[ci.key] = cozyLineIdentity(ci); });
      cozyPrevIds = [];
      cozyDisplayKeys.forEach(function(k) { if (cozyIdByKey[k]) cozyPrevIds.push(cozyIdByKey[k]); });
      if (cozyPrevIds.length === liveCart.items.length) {
        cozySwapSlot = cozyDisplayKeys.indexOf(itemKey);
      } else {
        /* DOM stale vs live cart — fall back to cart order */
        cozyPrevIds = liveCart.items.map(cozyLineIdentity);
        for (var ps = 0; ps < liveCart.items.length; ps++) {
          if (liveCart.items[ps].key === itemKey) { cozySwapSlot = ps; break; }
        }
      }
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemKey, quantity: 0 })
      });
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      /* Check if the new variant already exists in cart after removing old one */
      var existingItem = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === String(newVariantId)) {
          existingItem = cart.items[i];
          break;
        }
      }
      /* 🔒 NEVER MERGE (TA 2026-08-11): a drawer swap must never fold this line
         into another cart line — each line stays individually editable. If Shopify
         would auto-merge (identical variant + identical properties), stamp a hidden
         _keep property so the line keeps its own identity. */
      var cozySwapProps = cozyCarriedProps || {};
      if (existingItem && JSON.stringify(existingItem.properties || {}) === JSON.stringify(cozySwapProps)) {
        cozySwapProps = Object.assign({}, cozySwapProps);
        cozySwapProps._keep = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      }
      return xhrCartAdd(parseInt(newVariantId, 10), quantity, cozySwapProps);
    })
    .then(function(r) { return r && r.json ? r.json() : r; })
    .then(function() {
      swatchSwapping = false;
      /* Stable full re-render (replaces the old one-card soft update): Shopify
         re-hashes EVERY line key on any mutation, so patching one card left the
         OTHER lines holding dead keys — their next click then misfired. A full
         render refreshes every key; cozyStableOrder keeps the visual order. */
      fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          updateCartCount(cart.item_count);
          renderCartDrawer(cozyStableOrder(cart, cozyPrevIds, cozySwapSlot));
        });
    })
    .catch(function(err) {
      console.error('Swatch swap error:', err);
      swatchSwapping = false;
      refreshCartDrawer();
    });
  }

  function handleCartSizeClick(sizeBtn) {
    if (swatchSwapping) return;
    var newVariantId = sizeBtn.getAttribute('data-variant-id');
    var itemKey = sizeBtn.getAttribute('data-item-key');
    var quantity = parseInt(sizeBtn.getAttribute('data-quantity') || '1', 10);
    var newSize = sizeBtn.getAttribute('data-size');
    if (!newVariantId || !itemKey) return;
    if (sizeBtn.classList.contains('new-footwear-cart-item__size-btn--active')) return;

    swatchSwapping = true;
    var cozyPrevIds = null, cozySwapSlot = -1;
    var cozyDisplayKeys = Array.prototype.map.call(document.querySelectorAll('.new-footwear-cart-item'), function(el) { return el.getAttribute('data-key'); });

    var cartItem = sizeBtn.closest('.new-footwear-cart-item');
    if (cartItem) {
      /* Update size name label */
      var sizeName = cartItem.querySelector('.new-footwear-cart-item__size-name');
      if (sizeName && newSize) sizeName.textContent = newSize;
      /* Update active size button */
      cartItem.querySelectorAll('.new-footwear-cart-item__size-btn').forEach(function(b) {
        b.classList.remove('new-footwear-cart-item__size-btn--active');
        b.style.pointerEvents = 'none';
      });
      sizeBtn.classList.add('new-footwear-cart-item__size-btn--active');
    }

    /* Personalization must survive the size swap too */
    var cozySizeCarriedProps = cozyLinePropsByKey[itemKey] || {};
    var cozySizeHasProps = Object.keys(cozySizeCarriedProps).length > 0;

    /* Same variant swap as swatch click: remove old variant, add new.
       Props read from the LIVE cart first - see colour-swap note above. */
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(function(liveCart) {
      for (var lc = 0; lc < liveCart.items.length; lc++) {
        if (liveCart.items[lc].key === itemKey) {
          cozySizeCarriedProps = liveCart.items[lc].properties || {};
          cozySizeHasProps = Object.keys(cozySizeCarriedProps).length > 0;
          break;
        }
      }
      /* Order must come from what the shopper SEES (the DOM), not the cart
         array — Shopify's array order diverges from the displayed order after
         the first stable-ordered render. */
      var cozyIdByKey = {};
      liveCart.items.forEach(function(ci) { cozyIdByKey[ci.key] = cozyLineIdentity(ci); });
      cozyPrevIds = [];
      cozyDisplayKeys.forEach(function(k) { if (cozyIdByKey[k]) cozyPrevIds.push(cozyIdByKey[k]); });
      if (cozyPrevIds.length === liveCart.items.length) {
        cozySwapSlot = cozyDisplayKeys.indexOf(itemKey);
      } else {
        /* DOM stale vs live cart — fall back to cart order */
        cozyPrevIds = liveCart.items.map(cozyLineIdentity);
        for (var ps = 0; ps < liveCart.items.length; ps++) {
          if (liveCart.items[ps].key === itemKey) { cozySwapSlot = ps; break; }
        }
      }
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemKey, quantity: 0 })
      });
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var existingItem = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === String(newVariantId)) {
          existingItem = cart.items[i];
          break;
        }
      }
      /* 🔒 NEVER MERGE (TA 2026-08-11) — see colour-swap note above. */
      var cozySizeSwapProps = cozySizeCarriedProps || {};
      if (existingItem && JSON.stringify(existingItem.properties || {}) === JSON.stringify(cozySizeSwapProps)) {
        cozySizeSwapProps = Object.assign({}, cozySizeSwapProps);
        cozySizeSwapProps._keep = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      }
      return xhrCartAdd(parseInt(newVariantId, 10), quantity, cozySizeSwapProps);
    })
    .then(function(r) { return r && r.json ? r.json() : r; })
    .then(function() {
      swatchSwapping = false;
      /* Full re-render in the PRE-swap display order — see cozyStableOrder */
      fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          updateCartCount(cart.item_count);
          renderCartDrawer(cozyStableOrder(cart, cozyPrevIds, cozySwapSlot));
        });
    })
    .catch(function(err) {
      console.error('Size swap error:', err);
      swatchSwapping = false;
      refreshCartDrawer();
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCartDrawer(cart); updateCartCount(); })
      .catch(function(err) { console.error('Cart update error:', err); });
  }

  function updateCartCount(count) {
    /* Re-render the header cart-icon-bubble section so the count badge is
       created/removed and the empty<->full cart icon swaps correctly, even
       when the page loaded with an empty cart. Authoritative from the server. */
    fetch('/?sections=cart-icon-bubble')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var markup = data && data['cart-icon-bubble'];
        if (!markup) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = markup;
        var fresh = tmp.querySelector('#shopify-section-cart-icon-bubble') || tmp.firstElementChild;
        var icon = document.getElementById('cart-icon-bubble');
        if (icon && fresh) icon.innerHTML = fresh.innerHTML;
      })
      .catch(function() {});
  }

  function startTimer() {
    var timerEl = document.getElementById('new-footwear-cart-timer-value');
    if (!timerEl) return;
    var minutes = 10, seconds = 0;
    setInterval(function() {
      if (seconds === 0) { if (minutes === 0) return; minutes--; seconds = 59; } else { seconds--; }
      timerEl.textContent = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
    }, 1000);
  }

  function handleStickyBar() {
    if (!stickyBar || !form) return;
    var formRect = form.getBoundingClientRect();
    if (formRect.bottom < 0) stickyBar.classList.add('new-footwear-sticky-bar--visible');
    else stickyBar.classList.remove('new-footwear-sticky-bar--visible');
  }

  /* ═══════════════════════════════════════════
     EVENT BINDINGS
     ═══════════════════════════════════════════ */

  /* On load: flag any size that's sold out in the preselected colour.
     (Colour is preselected; size deliberately is not — locked rule.) */
  if (product && variants.length) {
    var initColorSwatch = document.querySelector('.new-footwear-product__color-swatch--active');
    var initOpts = [];
    if (initColorSwatch && colorOptionIndex >= 0) {
      initOpts[colorOptionIndex] = initColorSwatch.getAttribute('data-value');
    }
    nfMarkSoldOutSizes(initOpts);
  }

  document.querySelectorAll('.new-footwear-product__color-swatch').forEach(function(swatch) {
    swatch.addEventListener('click', function() {
      var optIndex = this.getAttribute('data-option-index');
      document.querySelectorAll('.new-footwear-product__color-swatch[data-option-index="' + optIndex + '"]')
        .forEach(function(s) { s.classList.remove('new-footwear-product__color-swatch--active'); });
      this.classList.add('new-footwear-product__color-swatch--active');
      updateVariant();
    });
  });

  document.querySelectorAll('.new-footwear-product__size-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var optIndex = this.getAttribute('data-option-index');
      document.querySelectorAll('.new-footwear-product__size-btn[data-option-index="' + optIndex + '"]')
        .forEach(function(b) { b.classList.remove('new-footwear-product__size-btn--active'); });
      this.classList.add('new-footwear-product__size-btn--active');
      nfHideSizeError();
      updateVariant();
    });
  });

  if (prevArrow) {
    prevArrow.addEventListener('click', function() { scrollGalleryBy(-getSlideStep()); });
  }
  if (nextArrow) {
    nextArrow.addEventListener('click', function() { scrollGalleryBy(getSlideStep()); });
  }

  if (thumbnails) {
    thumbnails.addEventListener('click', function(e) {
      var thumb = e.target.closest('.new-footwear-product__thumbnail');
      if (!thumb) return;
      var globalIndex = parseInt(thumb.getAttribute('data-index'), 10);
      showGalleryImageByGlobalIndex(globalIndex);
    });
  }

  if (dotsContainer) {
    dotsContainer.addEventListener('click', function(e) {
      var dot = e.target.closest('.new-footwear-product__gallery-dot');
      if (!dot) return;
      var dotIndex = parseInt(dot.getAttribute('data-dot-index'), 10);
      scrollToVisibleIndex(dotIndex, true);
      highlightVisibleThumb(dotIndex);
      updateDotActive(dotIndex);
    });
  }

  if (galleryMain) {
    galleryMain.addEventListener('click', function(e) {
      var imageDiv = e.target.closest('.new-footwear-product__gallery-image');
      if (!imageDiv) return;
      if (imageDiv.classList.contains('new-footwear-product__gallery-image--zoomed')) {
        imageDiv.classList.remove('new-footwear-product__gallery-image--zoomed');
      } else {
        galleryMain.querySelectorAll('.new-footwear-product__gallery-image--zoomed')
          .forEach(function(el) { el.classList.remove('new-footwear-product__gallery-image--zoomed'); });
        imageDiv.classList.add('new-footwear-product__gallery-image--zoomed');
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var zoomed = document.querySelector('.new-footwear-product__gallery-image--zoomed');
        if (zoomed) zoomed.classList.remove('new-footwear-product__gallery-image--zoomed');
      }
    });

    var scrollSyncRaf;
    galleryMain.addEventListener('scroll', function() {
      if (scrollSyncRaf) cancelAnimationFrame(scrollSyncRaf);
      scrollSyncRaf = requestAnimationFrame(function() {
        syncScrollToSlideIndex();
        updateArrowState();
      });
    }, { passive: true });
  }

  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!nfRequireSize()) return;
      var variantId = variantSelect ? variantSelect.value : null;
      if (variantId) addToCart(variantId, 1);
    }, true);
  }
  if (stickyAtc) {
    stickyAtc.addEventListener('click', function() {
      if (!nfRequireSize()) return;
      var variantId = variantSelect ? variantSelect.value : null;
      if (variantId) addToCart(variantId, 1);
    });
  }
  if (cartClose) { cartClose.addEventListener('click', closeCartDrawer); }

  /* Intercept Shopify header cart icon to open our custom drawer */
  var headerCartIcon = document.getElementById('cart-icon-bubble');
  if (headerCartIcon) {
    headerCartIcon.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      refreshCartDrawer();
      openCartDrawer();
    });
  }

  if (cartOverlay) {
    cartOverlay.addEventListener('click', function(e) {
      if (e.target === cartOverlay) closeCartDrawer();
    });
  }
  document.addEventListener('click', function(e) {
    if (cartDrawer && cartDrawer.classList.contains('new-footwear-cart-drawer--open') &&
        !cartDrawer.contains(e.target) && e.target !== cartOverlay) {
      closeCartDrawer();
    }
  });
  var continueShoppingBtn = document.querySelector('.new-footwear-cart-continue');
  if (continueShoppingBtn) { continueShoppingBtn.addEventListener('click', closeCartDrawer); }
  if (cartLineItems) { cartLineItems.addEventListener('click', handleCartItemClick); }

  /* Expose cart drawer controls globally so other sections (e.g. recommendations) can open the drawer */
  window.NewFootwearCart = window.NewFootwearCart || {};
  window.NewFootwearCart.open = openCartDrawer;
  window.NewFootwearCart.refresh = refreshCartDrawer;
  window.NewFootwearCart.openAndRefresh = function() {
    refreshCartDrawer();
    openCartDrawer();
  };
  window.addEventListener('scroll', handleStickyBar, { passive: true });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('new-footwear-cart-drawer--open')) {
      closeCartDrawer();
    }
  });

  var resizeDebounce;
  window.addEventListener('resize', function() {
    clearTimeout(resizeDebounce);
    resizeDebounce = setTimeout(function() {
      buildDots();
      updateArrowState();
    }, 200);
  });

  /* Size Guide Modal */
  var sizeGuideBtn = document.querySelector('[data-size-guide]');
  var sizeGuideModal = document.getElementById('new-footwear-size-guide-modal');
  var sizeGuideOverlay = document.getElementById('new-footwear-size-guide-overlay');
  var sizeGuideClose = document.getElementById('new-footwear-size-guide-close');

  function openSizeGuide() {
    if (sizeGuideModal) sizeGuideModal.classList.add('new-footwear-size-guide-modal--open');
    if (sizeGuideOverlay) sizeGuideOverlay.classList.add('new-footwear-size-guide-overlay--open');
  }
  function closeSizeGuide() {
    if (sizeGuideModal) sizeGuideModal.classList.remove('new-footwear-size-guide-modal--open');
    if (sizeGuideOverlay) sizeGuideOverlay.classList.remove('new-footwear-size-guide-overlay--open');
  }
  if (sizeGuideBtn) {
    sizeGuideBtn.addEventListener('click', function(e) { e.preventDefault(); openSizeGuide(); });
  }
  if (sizeGuideClose) { sizeGuideClose.addEventListener('click', closeSizeGuide); }
  if (sizeGuideOverlay) { sizeGuideOverlay.addEventListener('click', closeSizeGuide); }
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && sizeGuideModal && sizeGuideModal.classList.contains('new-footwear-size-guide-modal--open')) closeSizeGuide();
  });

  /* ═══════════════════════════════════════════
     INIT
     ═══════════════════════════════════════════ */
  (function init() {
    if (galleryMain) {
      currentVisibleImages = Array.from(
        galleryMain.querySelectorAll('.new-footwear-product__gallery-image')
      );
    }
    if (thumbnails) {
      currentVisibleThumbs = Array.from(
        thumbnails.querySelectorAll('.new-footwear-product__thumbnail')
      );
    }

    /* Filter to the initially selected color on page load */
    if (colorOptionIndex >= 0) {
      var activeSwatch = document.querySelector(
        '.new-footwear-product__color-swatch--active[data-option-index="' + colorOptionIndex + '"]'
      );
      if (activeSwatch) {
        var initialColor = activeSwatch.getAttribute('data-value');
        if (initialColor) filterGalleryByColor(initialColor);
      }
    }

    if (currentColorFilter === null) showAllImages();

    updateCartCount();
    startTimer();
    buildDots();
    updateArrowState();
  })();
})();
